export const translations = {
  el: {
    "nav.courses": "Μαθήματα",
    "nav.games": "Παιχνίδια",
    "nav.certificates": "Πιστοποιητικά",
    "certs.badge": "Οι πιστοποιήσεις μου",
    "certs.title": "Τα Πιστοποιητικά μου",
    "certs.subtitle": "Όλα τα πιστοποιητικά που έχεις κερδίσει, με έναν κλικ για προσθήκη στο προφίλ σου στο LinkedIn.",
    "certs.empty": "Δεν έχεις πιστοποιητικά ακόμη. Ολοκλήρωσε ένα μάθημα και πέρασε το τελικό quiz με 90%.",
    "certs.browse": "Δες τα μαθήματα",
    "certs.verified": "Επαληθεύσιμο πιστοποιητικό",
    "certs.internal": "Πιστοποιητικό SportScience",
    "certs.holder": "Στο όνομα",
    "certs.downloadPdf": "Λήψη PDF",
    "live.interactive": "Διαδραστική ενότητα",
    "live.slidesDone": "Ολοκλήρωσες τις διαδραστικές διαφάνειες!",
    "live.slidesScore": "Σωστά",
    "live.restart": "Ξανά από την αρχή",
    "live.fullText": "Πλήρες κείμενο ενότητας (από το απλό στο προχωρημένο)",
    "badges.title": "Τα σήματά μου",
    "badges.subtitle": "Ένα μοναδικό σήμα για κάθε μάθημα που ολοκληρώνεις — και επίπεδα Bronze, Silver, Gold όσο προχωράς.",
    "badges.courses": "μαθήματα",
    "badges.next": "Επόμενο επίπεδο",
    "badges.moreCourses": "ακόμη μάθημα/ματα",
    "badges.empty": "Ολοκλήρωσε το πρώτο σου μάθημα για να κερδίσεις το πρώτο σήμα!",
    "badges.share": "LinkedIn",
    "badges.youEarn": "Τι θα κερδίσεις",
    "badges.courseBadge": "Σήμα ολοκλήρωσης + πιστοποιητικό",
    "badges.courseBadgeDesc": "Με την επιτυχία στο τελικό quiz κερδίζεις το μοναδικό σήμα του μαθήματος (PNG για LinkedIn) και πιστοποιητικό με ID, barcode και QR.",
    "verify.badge": "Επαλήθευση",
    "verify.title": "Επαλήθευση Πιστοποιητικού",
    "verify.valid": "Έγκυρο πιστοποιητικό",
    "verify.invalid": "Το πιστοποιητικό δεν βρέθηκε",
    "verify.invalidHint": "Έλεγξε το ID ή σκάναρε ξανά το barcode/QR από το πιστοποιητικό.",
    "verify.issued": "Ημ/νία έκδοσης",
    "certs.score": "Βαθμός",
    "certs.addLinkedin": "Πρόσθεσε στο LinkedIn",
    "certs.verify": "Επαλήθευση",
    "certs.openCourse": "Άνοιξε το μάθημα",
    "certs.instagram": "Κάρτα για Instagram",
    "certs.cardBadge": "Πιστοποίηση ολοκληρώθηκε",
    "certs.cardReady": "Η κάρτα κατέβηκε! Ανέβασέ τη στο Instagram.",
    "certs.cardError": "Δεν ήταν δυνατή η δημιουργία της κάρτας.",
    "admin.tab.sales": "Πωλήσεις",
    "admin.sales.empty": "Δεν υπάρχουν πωλήσεις ακόμη.",
    "admin.sales.total": "Πωλήσεις",
    "admin.sales.revenue": "Έσοδα",
    "admin.sales.pending": "Σε εκκρεμότητα",
    "admin.sales.enrollments": "Εγγραφές",
    "admin.sales.certificates": "Πιστοποιητικά",
    "admin.sales.byCourse": "Ανά μάθημα",
    "admin.sales.byCoupon": "Ανά κωδικό έκπτωσης",
    "nav.learn": "Διαδραστικά",
    "nav.academy": "Μαθήματα Online",
    "academy.badge": "Self-paced μαθήματα",
    "academy.title": "Online Μαθήματα για Γυμναστές",
    "academy.subtitle": "Σύντομα, διαδραστικά μαθήματα με διαφάνειες, checkpoints και role-playing σενάρια. Έτοιμη ύλη, πιστοποιητικό ολοκλήρωσης και πρόσβαση για πάντα μετά την αγορά.",
    "academy.filters": "Φίλτρα",
    "academy.allCategories": "Όλες οι κατηγορίες",
    "academy.allPrices": "Όλες οι τιμές",
    "academy.freeOnly": "Δωρεάν",
    "academy.empty": "Δεν βρέθηκαν μαθήματα με αυτά τα φίλτρα.",
    "academy.free": "Δωρεάν",
    "academy.owned": "Το έχεις",
    "academy.details": "Οδηγός σπουδών",
    "academy.continue": "Συνέχισε",
    "academy.backToCatalog": "Πίσω στα μαθήματα",
    "academy.whatYouLearn": "Τι θα μάθεις",
    "academy.syllabus": "Ύλη μαθήματος",
    "academy.faq": "Συχνές ερωτήσεις",
    "cfaq1.q": "Πότε ξεκινάω και πόσο διαρκεί η πρόσβαση;",
    "cfaq1.a": "Αμέσως μετά την αγορά. Η πρόσβαση είναι εφ' όρου ζωής — μελετάς με τον δικό σου ρυθμό, από υπολογιστή ή κινητό.",
    "cfaq2.q": "Πώς λειτουργούν οι διαδραστικές ενότητες;",
    "cfaq2.a": "Κάθε ενότητα αποτελείται από διαφάνειες θεωρίας, checkpoints, ασκήσεις αντιστοίχισης και σενάρια ρόλων. Κερδίζεις XP και badges όσο προχωράς.",
    "cfaq3.q": "Πώς παίρνω το πιστοποιητικό;",
    "cfaq3.a": "Ολοκληρώνεις όλες τις ενότητες και περνάς το τελικό quiz (βάση 90%). Το πιστοποιητικό με μοναδικό ID, barcode και QR επαλήθευσης σου έρχεται αυτόματα με email και μπορείς να το μοιραστείς στο LinkedIn.",
    "cfaq4.q": "Είναι το υλικό διαθέσιμο στα αγγλικά;",
    "cfaq4.a": "Ναι, όλα τα online μαθήματα είναι δίγλωσσα. Αλλάζεις γλώσσα ανά πάσα στιγμή από το μενού.",
    "cfaq5.q": "Μπορώ να δοκιμάσω πριν αγοράσω;",
    "cfaq5.a": "Ναι — η πρώτη ενότητα κάθε μαθήματος είναι δωρεάν προεπισκόπηση. Πάτησε «Δοκίμασε δωρεάν» για να τη δεις.",
    "academy.slides": "διαφάνειες",
    "academy.slide": "Διαφάνεια",
    "academy.previewFree": "δωρεάν δείγμα",
    "academy.locked": "Κλειδωμένο",
    "academy.oneTime": "Μία πληρωμή, πρόσβαση για πάντα",
    "academy.selfPaced": "με τον ρυθμό σου",
    "academy.certificateAt": "Πιστοποιητικό με 90% στο τελικό quiz",
    "academy.youHaveAccess": "Έχεις πρόσβαση σε αυτό το μάθημα",
    "academy.buyNow": "Απόκτησε πρόσβαση",
    "academy.paymentNote": "Ασφαλής πληρωμή με κάρτα, Google Pay, Apple Pay ή Klarna.",
    "academy.tryPreview": "Δες το δωρεάν δείγμα",
    "academy.finalQuiz": "Τελικό quiz & πιστοποιητικό",
    "academy.ownCert": "Επαληθεύσιμο πιστοποιητικό SportScience Academy με QR & μοναδικό ID",
    "cert.previewEyebrow": "Τι κερδίζεις",
    "cert.previewTitle": "Δείγμα πιστοποιητικού",
    "cert.certifies": "Πιστοποιείται ότι",
    "cert.holderPlaceholder": "Το Όνομά Σου",
    "cert.completed": "ολοκλήρωσε επιτυχώς το πρόγραμμα",
    "cert.hours": "ώρες εκπαίδευσης",
    "cert.idLine": "Credential ID · QR επαλήθευσης",
    "cert.verified": "Verified by SportScience Academy",
    "cert.previewNote": "Το πιστοποιητικό εκδίδεται ψηφιακά από τη SportScience Academy με μοναδικό ID, barcode και QR επαλήθευσης, και μπορείς να το μοιραστείς στο LinkedIn.",
    "courses.tabLive": "7μηνα Διπλώματα (εξ αποστάσεως)",
    "courses.tabOnline": "Online μαθήματα",
    "academy.bilingual": "Διαθέσιμο σε Ελληνικά & Αγγλικά — επιλέγεις γλώσσα μέσα στο μάθημα",
    "academy.manualIncluded": "Περιλαμβάνει το πλήρες εγχειρίδιο (PDF)",
    "academy.downloadManual": "Κατέβασε το εγχειρίδιο (PDF)",
    "academy.quizIntro": "Χρειάζεσαι 90% για να λάβεις πιστοποιητικό. Μπορείς να ξαναπροσπαθήσεις όσες φορές θέλεις.",
    "academy.attempts": "Προσπάθειες",
    "academy.submitQuiz": "Υποβολή",
    "academy.passed": "Πέρασες! Το πιστοποιητικό εκδόθηκε.",
    "academy.failed": "Δεν έφτασες το 90% — ξαναπροσπάθησε.",
    "academy.retry": "Ξαναπροσπάθησε",
    "academy.certificateIssued": "Πιστοποιητικό",
    "academy.coachNote": "Σημείωση coach",
    "academy.couponPlaceholder": "Κωδικός έκπτωσης",
    "academy.couponApply": "Εφαρμογή",
    "academy.couponApplied": "Ο κωδικός εφαρμόστηκε!",
    "admin.tab.coupons": "Κουπόνια",
    "admin.newCoupon": "Νέο κουπόνι",
    "admin.coupons.empty": "Δεν υπάρχουν κουπόνια.",
    "admin.coupons.saved": "Ο κωδικός αποθηκεύτηκε",
    "academy.verifyCertificate": "Δες το επαληθεύσιμο πιστοποιητικό",
    "admin.coupons.used": "Χρήσεις",
    "admin.coupons.expires": "Λήγει",
    "admin.coupons.active": "Ενεργό",
    "admin.coupons.inactive": "Ανενεργό",
    "admin.field.couponCode": "Κωδικός",
    "admin.field.couponType": "Τύπος",
    "admin.field.couponPercent": "Ποσοστό (%)",
    "admin.field.couponAmount": "Σταθερό ποσό (€)",
    "admin.field.couponValue": "Τιμή έκπτωσης",
    "admin.field.couponMaxUses": "Μέγιστες χρήσεις (0 = άπειρες)",
    "admin.field.couponExpires": "Ημερομηνία λήξης",
    "academy.nextSlide": "Επόμενη διαφάνεια",
    "payment.checking": "Επιβεβαιώνουμε την πληρωμή σου...",
    "payment.success": "Η πληρωμή ολοκληρώθηκε!",
    "payment.accessGranted": "Το μάθημα ξεκλειδώθηκε στον λογαριασμό σου.",
    "payment.startNow": "Ξεκίνα τώρα",
    "payment.pending": "Η πληρωμή εκκρεμεί. Θα ξεκλειδώσει αυτόματα μόλις επιβεβαιωθεί.",
    "payment.failed": "Η πληρωμή δεν ολοκληρώθηκε.",
    "payment.cancelled": "Η πληρωμή ακυρώθηκε",
    "payment.cancelledNote": "Δεν χρεώθηκε τίποτα. Μπορείς να δοκιμάσεις ξανά όποτε θέλεις.",
    "admin.tab.academy": "Online Μαθήματα",
    "admin.newAcademyCourse": "Νέο online μάθημα",
    "admin.newAcademyLesson": "Νέα ενότητα",
    "admin.academy.empty": "Δεν υπάρχουν online μαθήματα.",
    "admin.academy.slidesHelp": "Slides σε JSON: slide, checkpoint, match, order, scenario.",
    "admin.field.academySlug": "Slug (URL)",
    "admin.field.academyCategory": "Κατηγορία",
    "admin.field.academyLevel": "Επίπεδο",
    "admin.field.academyHours": "Ώρες",
    "admin.field.academyPrice": "Τιμή (€)",
    "admin.field.academyOriginal": "Αρχική τιμή (€)",
    "admin.field.academyLookup": "Stripe lookup key",
    "admin.field.academyPreview": "Δωρεάν δείγμα",
    "admin.field.academySlides": "Slides (JSON)",
    "admin.field.academyQuiz": "Τελικό quiz (JSON)",
    "learn.badge": "Διαδραστική μάθηση",
    "learn.title": "Διαδραστικά Μαθήματα",
    "learn.subtitle": "Μάθε βήμα-βήμα: μικρά σκαλοπάτια θεωρίας, checkpoints με άμεσο feedback, ασκήσεις και role-playing σενάρια όπου παίρνεις εσύ τις αποφάσεις του coach.",
    "learn.empty": "Δεν υπάρχουν διαδραστικά μαθήματα ακόμη.",
    "learn.lessons": "μαθήματα",
    "learn.steps": "βήματα",
    "learn.start": "Ξεκίνα",
    "learn.continueCourse": "Συνέχισε",
    "learn.review": "Επανάληψη",
    "learn.back": "Πίσω",
    "learn.step": "Βήμα",
    "learn.lessonNo": "Μάθημα",
    "learn.theory": "Θεωρία",
    "learn.checkpoint": "Checkpoint",
    "learn.exercise": "Άσκηση",
    "learn.roleplay": "Role-playing",
    "learn.gotIt": "Το κατάλαβα",
    "learn.continue": "Συνέχεια",
    "learn.correct": "Σωστά!",
    "learn.notQuite": "Όχι ακριβώς.",
    "learn.matchHint": "Διάλεξε πρώτα αριστερά και μετά το ταίρι του δεξιά.",
    "learn.reset": "Καθάρισε",
    "learn.decision": "Απόφαση",
    "learn.consequence": "Συνέπεια",
    "learn.nextDecision": "Επόμενη απόφαση",
    "learn.debrief": "Debrief",
    "learn.completed": "Ολοκληρώθηκε",
    "learn.alreadyDone": "Το είχες ολοκληρώσει — αυτή τη φορά δεν κερδίζεις XP.",
    "learn.nextLesson": "Επόμενο μάθημα",
    "learn.again": "Ξανά",
    "admin.tab.learn": "Διαδραστικά",
    "admin.newLearnCourse": "Νέο διαδραστικό μάθημα",
    "admin.newLearnLesson": "Νέα ενότητα",
    "admin.learn.empty": "Δεν υπάρχουν διαδραστικά μαθήματα.",
    "admin.learn.lessonsFor": "Ενότητες",
    "admin.learn.blocksHelp": "Τα blocks σε μορφή JSON: theory, checkpoint, match, order, scenario.",
    "admin.field.learnSubtitle": "Υπότιτλος",
    "admin.field.learnBlocks": "Blocks (JSON)",
    "admin.field.learnXp": "XP",
    "games.badge": "Μάθε παίζοντας",
    "games.title": "Παιχνίδια",
    "games.subtitle": "Επτά γρήγορα παιχνίδια που εμπεδώνουν την ύλη: ερωτήσεις με χρονόμετρο, σωστό/λάθος sprint, κάρτες, ζευγάρια μνήμης, μάντεψε τον όρο, σενάρια προπόνησης και η Εβδομαδιαία Πρόκληση. Κερδίζεις XP, μαζεύεις πόντους και ανταγωνίζεσαι στην κατάταξη.",
    "games.cta": "Παίξε & μάθε",
    "games.play": "Παίξε",
    "games.playAgain": "Παίξε ξανά",
    "games.back": "Πίσω στα παιχνίδια",
    "games.best": "Ρεκόρ",
    "games.plays": "παιχνίδια",
    "games.noContent": "Δεν υπάρχει ακόμη περιεχόμενο.",
    "games.leaderboard": "Κατάταξη παιχνιδιών",
    "games.leaderboardEmpty": "Κανείς δεν έχει παίξει ακόμη. Γίνε ο πρώτος!",
    "games.xpToday": "XP σήμερα από παιχνίδια",
    "games.capReached": "Έφτασες το ημερήσιο όριο XP από παιχνίδια. Συνέχισε για την πλάκα!",
    "games.result": "Αποτέλεσμα",
    "games.correct": "Σωστά",
    "games.accuracy": "Ακρίβεια",
    "games.xpEarned": "XP που κέρδισες",
    "games.question": "Ερώτηση",
    "games.scenario": "Σενάριο",
    "games.true": "Σωστό",
    "games.false": "Λάθος",
    "games.term": "Όρος",
    "games.answer": "Απάντηση",
    "games.reveal": "Δες την απάντηση",
    "games.knew": "Το ήξερα",
    "games.didntKnow": "Δεν το ήξερα",
    "games.yourOrder": "Η σειρά σου",
    "games.availableSteps": "Διαθέσιμα βήματα",
    "games.pickSteps": "Διάλεξε βήματα με τη σωστή σειρά.",
    "games.undo": "Αναίρεση",
    "games.finish": "Τέλος",
    "games.nextScenario": "Επόμενο σενάριο",
    "games.hint": "Οι απαντήσεις ελέγχονται στον server — καλή τύχη!",
    "games.quiz-rush.title": "Quiz Rush",
    "games.quiz-rush.desc": "10 ερωτήσεις, 15 δευτερόλεπτα η καθεμία. Κράτα το streak ψηλά.",
    "games.tf-sprint.title": "Σωστό / Λάθος Sprint",
    "games.tf-sprint.desc": "60 δευτερόλεπτα. Όσα περισσότερα σωστά μπορείς.",
    "games.flashcards.title": "Flashcards",
    "games.flashcards.desc": "Κάρτες όρων με επανάληψη σε ό,τι δεν ήξερες.",
    "games.build-session.title": "Χτίσε την Προπόνηση",
    "games.build-session.desc": "Βάλε τα βήματα μιας προπονητικής μονάδας στη σωστή σειρά.",
    "games.memory-match.title": "Βρες το Ζευγάρι",
    "games.memory-match.desc": "Αντιστοίχισε 6 όρους με τους ορισμούς τους σε 90 δευτερόλεπτα. Λιγότερες κινήσεις, καλύτερη μνήμη.",
    "games.word-guess.title": "Μάντεψε τον Όρο",
    "games.word-guess.desc": "Διάβασε την περιγραφή και γράψε τον αθλητικό όρο. Το πρώτο γράμμα σου δίνεται.",
    "games.weekly-challenge.title": "Εβδομαδιαία Πρόκληση",
    "games.weekly-challenge.desc": "15 ερωτήσεις, ίδιες για όλους αυτή την εβδομάδα. Η κατάταξη μηδενίζει κάθε Δευτέρα — πάρε την κορυφή!",
    "games.moves": "Κινήσεις",
    "games.typeWord": "Γράψε τον όρο…",
    "games.guess": "Απάντηση",
    "games.skip": "Παράλειψη",
    "games.week": "Εβδομάδα",
    "games.weeklyBoard": "Κατάταξη Εβδομάδας",
    "games.weeklyBoardHint": "Μόνο η Εβδομαδιαία Πρόκληση μετράει εδώ. Μηδενίζει κάθε Δευτέρα.",
    "coach.badge": "Coach",
    "coach.title": "Μπράβο, τα κατάφερες!",
    "coach.lessonDone": "Μπράβο, τα κατάφερες!",
    "coach.courseDone": "Συγχαρητήρια, πέρασες!",
    "coach.newBadge": "Νέο badge",
    "coach.noBadges": "Συνέχισε έτσι — τα πρώτα badges έρχονται σύντομα!",
    "coach.continue": "Συνέχεια",
    "learn.video": "Βίντεο",
    "badge.game_master": "Game Master",
    "admin.tab.games": "Παιχνίδια",
    "admin.newGameItem": "Νέο στοιχείο",
    "admin.games.empty": "Δεν υπάρχουν στοιχεία παιχνιδιών.",
    "admin.field.gameType": "Τύπος",
    "admin.field.gamePrompt": "Ερώτηση / Όρος / Σενάριο",
    "admin.field.gameOptions": "Επιλογές (μία ανά γραμμή)",
    "admin.field.gameCorrect": "Σωστή επιλογή (0-3)",
    "admin.field.gameAnswer": "Η πρόταση είναι σωστή",
    "admin.field.gameBack": "Πίσω όψη κάρτας",
    "admin.field.gameSteps": "Βήματα με σωστή σειρά (ένα ανά γραμμή)",
    "admin.field.gameExplanation": "Εξήγηση",
    "admin.field.gameCategory": "Κατηγορία",
    "nav.articles": "Άρθρα",
    "articles.badge": "Blog & Γνώση",
    "articles.title": "Άρθρα",
    "articles.subtitle": "Πρακτική γνώση για προπονητές και αθλητές: φυσική προετοιμασία, αξιολόγηση, πρόληψη τραυματισμών και περιοδικότητα.",
    "articles.empty": "Δεν υπάρχουν άρθρα ακόμη.",
    "articles.read": "Διάβασε",
    "articles.back": "Πίσω στα άρθρα",
    "newsletter.badge": "Newsletter",
    "newsletter.title": "Μείνε ενημερωμένος με κάθε νέο άρθρο",
    "newsletter.subtitle": "Γράψου στο newsletter και λαμβάνεις email με κάθε νέο άρθρο της SportScience Academy. Χωρίς spam, διαγραφή όποτε θέλεις.",
    "newsletter.placeholder": "Το email σου",
    "newsletter.cta": "Εγγραφή",
    "newsletter.success": "Γράφτηκες στο newsletter!",
    "admin.tab.articles": "Άρθρα",
    "admin.tab.subscribers": "Newsletter",
    "admin.newArticle": "Νέο άρθρο",
    "admin.articles.empty": "Δεν υπάρχουν άρθρα.",
    "admin.subscribers.empty": "Δεν υπάρχουν εγγεγραμμένοι.",
    "admin.articles.published": "Δημοσιευμένο",
    "admin.articles.draft": "Πρόχειρο",
    "admin.articles.sendNewsletter": "Στείλε newsletter",
    "admin.articles.sent": "Το newsletter στάλθηκε",
    "admin.field.artTitle": "Τίτλος",
    "admin.field.artExcerpt": "Περίληψη",
    "admin.field.artContent": "Κείμενο",
    "admin.field.artCover": "Εικόνα (URL)",
    "admin.field.artAuthor": "Συντάκτης",
    "admin.field.artPublished": "Δημοσίευση (στέλνει newsletter)",
    "nav.dashboard": "Η Πρόοδός μου",
    "nav.admin": "Διαχείριση",
    "nav.login": "Σύνδεση",
    "nav.register": "Εγγραφή",
    "nav.logout": "Έξοδος",
    "hero.badge": "Online Αθλητική Εκπαίδευση",
    "hero.title1": "Χτίσε Skills.",
    "hero.title2": "Γίνε Ειδικός.",
    "hero.subtitle": "Η SportScience Academy σου δίνει πρόσβαση σε μαθήματα αθλητικής επιστήμης με δομημένη ύλη, quiz μετά από κάθε μάθημα και πλήρη παρακολούθηση προόδου — όπου κι αν βρίσκεσαι.",
    "hero.cta": "Ξεκίνα Τώρα",
    "hero.cta2": "Δες τα Μαθήματα",
    "stats.courses": "Μαθήματα",
    "stats.lessons": "Ενότητες Ύλης",
    "stats.quiz": "Quiz Αξιολόγησης",
    "features.title": "Γιατί SportScience Academy",
    "features.subtitle": "Μια πλατφόρμα σχεδιασμένη για αποτέλεσμα, όχι απλά παρακολούθηση.",
    "feature1.title": "Δομημένη Ύλη",
    "feature1.desc": "Κάθε μάθημα είναι οργανωμένο σε ενότητες με καθαρή θεωρία και πρακτική εφαρμογή από την αθλητική επιστήμη.",
    "feature2.title": "Quiz μετά από κάθε μάθημα",
    "feature2.desc": "Άμεση αξιολόγηση με instant score. Ξέρεις πάντα πού βρίσκεσαι και τι πρέπει να επαναλάβεις.",
    "feature3.title": "Παρακολούθηση Προόδου",
    "feature3.desc": "Προσωπικό dashboard με ποσοστά ολοκλήρωσης και μέσο όρο επιδόσεων ανά μάθημα.",
    "feature4.title": "Μάθε Οπουδήποτε",
    "feature4.desc": "100% online, από οποιαδήποτε συσκευή, με τον δικό σου ρυθμό και το δικό σου πρόγραμμα.",
    "landing.popular.title": "Δημοφιλή Μαθήματα",
    "landing.popular.subtitle": "Τα μαθήματα που ξεχωρίζουν οι σπουδαστές μας",
    "landing.courses.title": "Δημοφιλή Προγράμματα",
    "landing.online.title": "Online Μαθήματα Academy",
    "landing.online.subtitle": "Μάθε με τον δικό σου ρυθμό",
    "landing.online.desc": "Διαδραστικά μαθήματα με slides, checkpoints και πιστοποίηση. Συνδέσου, απόκτησε πρόσβαση και ξεκίνα άμεσα.",
    "landing.courses.subtitle": "Ξεκίνα από τα θεμέλια της αθλητικής επιστήμης",
    "landing.cta.title": "Έτοιμος να ανεβάσεις επίπεδο;",
    "landing.cta.subtitle": "Δημιούργησε λογαριασμό και ξεκίνα το πρώτο σου μάθημα σήμερα.",
    "courses.title": "Κατάλογος Μαθημάτων",
    "courses.subtitle": "Διάλεξε το επόμενο βήμα στην εξέλιξή σου",
    "courses.lessons": "ενότητες",
    "courses.view": "Προβολή Μαθήματος",
    "level.Beginner": "Αρχάριο",
    "level.Intermediate": "Μεσαίο",
    "level.Advanced": "Προχωρημένο",
    "auth.login.title": "Καλωσήρθες ξανά",
    "auth.login.subtitle": "Συνδέσου για να συνεχίσεις από εκεί που σταμάτησες.",
    "auth.register.title": "Δημιούργησε λογαριασμό",
    "auth.register.subtitle": "Ξεκίνα το ταξίδι σου στην αθλητική επιστήμη σήμερα.",
    "auth.name": "Ονοματεπώνυμο",
    "auth.email": "Email",
    "auth.password": "Κωδικός",
    "auth.login.submit": "Σύνδεση",
    "auth.register.submit": "Δημιουργία Λογαριασμού",
    "auth.noAccount": "Δεν έχεις λογαριασμό;",
    "auth.hasAccount": "Έχεις ήδη λογαριασμό;",
    "auth.forgot.link": "Ξέχασες τον κωδικό σου;",
    "auth.forgot.title": "Επαναφορά κωδικού",
    "auth.forgot.subtitle": "Δώσε το email σου και θα σου στείλουμε ασφαλή σύνδεσμο για να ορίσεις νέο κωδικό.",
    "auth.forgot.submit": "Στείλε μου σύνδεσμο",
    "auth.forgot.sentTitle": "Έλεγξε το email σου",
    "auth.forgot.sentBody": "Αν υπάρχει λογαριασμός με αυτό το email, μόλις σου στείλαμε σύνδεσμο επαναφοράς. Λήγει σε 1 ώρα.",
    "auth.reset.title": "Όρισε νέο κωδικό",
    "auth.reset.subtitle": "Διάλεξε έναν νέο κωδικό τουλάχιστον 6 χαρακτήρων.",
    "auth.reset.newPassword": "Νέος κωδικός",
    "auth.reset.confirm": "Επιβεβαίωση κωδικού",
    "auth.reset.submit": "Αποθήκευση κωδικού",
    "auth.reset.mismatch": "Οι κωδικοί δεν ταιριάζουν.",
    "auth.reset.invalidTitle": "Μη έγκυρος σύνδεσμος",
    "auth.reset.invalidBody": "Ο σύνδεσμος επαναφοράς δεν είναι έγκυρος. Ζήτησε νέον για να συνεχίσεις.",
    "auth.reset.done": "Ο κωδικός άλλαξε. Συνδέσου με τον νέο σου κωδικό.",
    "course.enroll": "Εγγραφή στο Μάθημα",
    "course.enrolled": "Είσαι εγγεγραμμένος",
    "course.curriculum": "Ύλη Μαθήματος",
    "course.progress": "Πρόοδος",
    "course.back": "Πίσω στα μαθήματα",
    "course.start": "Έναρξη",
    "course.quizCount": "ερωτήσεις",
    "lesson.content": "Ύλη Μαθήματος",
    "lesson.completed": "Ολοκληρώθηκε",
    "lesson.next": "Επόμενο Μάθημα",
    "lesson.backToCourse": "Επιστροφή στο Μάθημα",
    "quiz.title": "Quiz Αξιολόγησης",
    "quiz.subtitle": "Απάντησε στις ερωτήσεις για να ολοκληρώσεις την ενότητα. Χρειάζεσαι τουλάχιστον 60%.",
    "quiz.submit": "Υποβολή Απαντήσεων",
    "quiz.score": "Το Σκορ σου",
    "quiz.passed": "Πέρασες! Η ενότητα ολοκληρώθηκε.",
    "quiz.failed": "Δεν τα κατάφερες αυτή τη φορά. Δοκίμασε ξανά!",
    "quiz.retake": "Επανάληψη Quiz",
    "quiz.selectAll": "Απάντησε σε όλες τις ερωτήσεις πριν την υποβολή.",
    "dash.title": "Η Πρόοδός μου",
    "dash.subtitle": "Στατιστικά και μαθήματα που παρακολουθείς",
    "dash.enrolled": "Εγγεγραμμένα Μαθήματα",
    "dash.completed": "Ολοκληρωμένες Ενότητες",
    "dash.attempts": "Προσπάθειες Quiz",
    "dash.avg": "Μέσος Όρος Quiz",
    "dash.myCourses": "Τα Μαθήματά μου",
    "dash.continue": "Συνέχεια",
    "dash.empty": "Δεν έχεις εγγραφεί ακόμα σε κάποιο μάθημα.",
    "dash.browse": "Εξερεύνησε Μαθήματα",
    "admin.title": "Διαχείριση Πλατφόρμας",
    "admin.subtitle": "Δημιούργησε και επεξεργάσου μαθήματα, ενότητες και quiz",
    "admin.courses": "Μαθήματα",
    "admin.newCourse": "Νέο Μάθημα",
    "admin.editCourse": "Επεξεργασία Μαθήματος",
    "admin.lessons": "Ενότητες",
    "admin.newLesson": "Νέα Ενότητα",
    "admin.editLesson": "Επεξεργασία Ενότητας",
    "admin.field.title": "Τίτλος",
    "admin.field.description": "Περιγραφή",
    "admin.field.category": "Κατηγορία",
    "admin.field.level": "Επίπεδο",
    "admin.field.thumbnail": "URL Εικόνας",
    "admin.field.content": "Περιεχόμενο Ύλης",
    "admin.field.video": "URL Βίντεο (YouTube/mp4, προαιρετικό)",
    "admin.save": "Αποθήκευση",
    "admin.cancel": "Ακύρωση",
    "admin.delete": "Διαγραφή",
    "admin.edit": "Edit",
    "admin.quiz": "Ερωτήσεις Quiz",
    "admin.addQuestion": "Προσθήκη Ερώτησης",
    "admin.question": "Ερώτηση",
    "admin.options": "Επιλογές",
    "admin.correct": "Σωστή Απάντηση",
    "admin.removeQuestion": "Αφαίρεση",
    "admin.selectCourse": "Επίλεξε μάθημα για επεξεργασία ή δημιούργησε νέο.",
    "admin.saved.course": "Το μάθημα αποθηκεύτηκε",
    "admin.saved.lesson": "Η ενότητα αποθηκεύτηκε",
    "admin.deleted.course": "Το μάθημα διαγράφηκε",
    "admin.deleted.lesson": "Η ενότητα διαγράφηκε",
    "courses.search": "Αναζήτηση μαθήματος...",
    "courses.allCategories": "Όλες οι κατηγορίες",
    "courses.allLevels": "Όλα τα επίπεδα",
    "courses.noResults": "Δεν βρέθηκαν μαθήματα με αυτά τα κριτήρια.",
    "courses.results": "αποτελέσματα",
    "lesson.notes": "Οι Σημειώσεις μου",
    "lesson.notesPlaceholder": "Κράτα σημειώσεις για αυτή την ενότητα...",
    "lesson.notesSave": "Αποθήκευση Σημειώσεων",
    "lesson.notesSaved": "Οι σημειώσεις αποθηκεύτηκαν",
    "lesson.bookmark": "Αποθήκευση στα Αγαπημένα",
    "lesson.bookmarked": "Στα Αγαπημένα",
    "quiz.review": "Ανάλυση Απαντήσεων",
    "quiz.yourAnswer": "Η απάντησή σου",
    "quiz.correctAnswer": "Σωστή απάντηση",
    "quiz.history": "Ιστορικό Προσπαθειών",
    "quiz.historyEmpty": "Δεν έχεις κάνει ακόμα προσπάθεια σε αυτό το quiz.",
    "quiz.showReview": "Δες αναλυτικά",
    "quiz.hideReview": "Κλείσε την ανάλυση",
    "dash.bookmarks": "Αγαπημένες Ενότητες",
    "dash.bookmarksEmpty": "Δεν έχεις αποθηκεύσει ενότητες στα αγαπημένα.",
    "dash.history": "Ιστορικό Quiz",
    "dash.historyEmpty": "Δεν υπάρχουν προσπάθειες quiz ακόμα.",
    "dash.open": "Άνοιγμα",
    "brand.tagline": "ΜΑΘΕ ΤΗΝ ΕΠΙΣΤΗΜΗ. ΑΛΛΑΞΕ ΤΟ ΠΑΙΧΝΙΔΙ.",
    "hero.eyebrow": "ΜΑΘΕ. ΕΦΑΡΜΟΣΕ. ΞΕΧΩΡΙΣΕ.",
    "hero.block1": "Τα skills σου.",
    "hero.block2": "Η γνώση σου.",
    "hero.block3": "Το παιχνίδι σου.",
    "hero.tag": "Μάθε online. Εφάρμοσε στο γήπεδο. Ξεχώρισε παντού.",
    "cats.eyebrow": "ΔΙΑΛΕΞΕ ΚΑΤΗΓΟΡΙΑ",
    "cats.title": "Δημοφιλείς κατηγορίες",
    "cats.title2": "μαθημάτων.",
    "cat.physiology": "Φυσιολογία & Προπόνηση",
    "cat.business": "Business in Fitness",
    "cat.populations": "Ειδικοί Πληθυσμοί",
    "cat.wellbeing": "Wellbeing Coaching",
    "cat.sports": "Ποδόσφαιρο & Μπάσκετ",
    "why.eyebrow": "ΓΙΑΤΙ SPORTSCIENCE ACADEMY",
    "why.title": "Μία πλατφόρμα. Αμέτρητες ευκαιρίες.",
    "why1.title": "Gamified Learning",
    "why1.desc": "Διαδραστικές διαφάνειες, checkpoints, παιχνίδια και XP. Μαθαίνεις παίζοντας, ανταγωνίζεσαι στην εβδομαδιαία κατάταξη και ο Coach σε επιβραβεύει σε κάθε επιτυχία.",
    "why2.title": "Role-Playing Σενάρια",
    "why2.desc": "Μπαίνεις στον ρόλο του προπονητή ή του γυμναστή, παίρνεις αποφάσεις σε ρεαλιστικά σενάρια και βλέπεις τις συνέπειες — όπως στο γήπεδο και στο γυμναστήριο.",
    "why3.title": "Επαληθεύσιμες Πιστοποιήσεις",
    "why3.desc": "Κάθε πιστοποιητικό έχει μοναδικό ID, barcode και QR επαλήθευσης. Μοιράσου το στο LinkedIn και δείξε στους εργοδότες τι ξέρεις.",
    "why4.title": "Career Mentorship",
    "why4.desc": "1-1 ή σε ομάδες 4-5, λύνεις πραγματικά προβλήματα καριέρας με έμπειρους επαγγελματίες του χώρου.",
    "why5.title": "Ελληνικά & Αγγλικά",
    "why5.desc": "Όλη η ύλη είναι δίγλωσση: μελέτησε στα ελληνικά, εξασκήσου στην ορολογία στα αγγλικά και ετοιμάσου για διεθνή καριέρα.",
    "cat.nutrition": "Διατροφή",
    "cat.strength": "Προπονητική",
    "cat.biomechanics": "Εμβιομηχανική",
    "cat.psychology": "Ψυχολογία",
    "steps.eyebrow": "ΠΩΣ ΛΕΙΤΟΥΡΓΕΙ",
    "steps.title": "Τέσσερα βήματα.",
    "steps.title2": "Μία διαδρομή.",
    "steps.subtitle": "Από την πρώτη ενότητα μέχρι το πρώτο σου πιστοποιημένο skill.",
    "step1.title": "Ξεκίνα με τον στόχο σου",
    "step1.desc": "Οραματίσου την καριέρα που θέλεις στον χώρο του fitness και της αθλητικής επιστήμης. Εμείς σου δείχνουμε τη διαδρομή.",
    "step2.title": "Μάθε μέσα από Role-Playing",
    "step2.desc": "Διαδραστικές διαφάνειες, σενάρια αποφάσεων και παιχνίδια που σε βάζουν στον ρόλο του επαγγελματία.",
    "step3.title": "Κέρδισε την πιστοποίηση",
    "step3.desc": "Πέρασε την τελική αξιολόγηση και πάρε πιστοποιητικό με μοναδικό ID, barcode και QR επαλήθευσης.",
    "step4.title": "Κατάκτησε τη δουλειά που θέλεις",
    "step4.desc": "Μοιράσου τα πιστοποιητικά στο LinkedIn, αξιοποίησε το mentorship και επιτάχυνε την καριέρα σου.",
    "stats.eyebrow": "ΤΑ ΝΟΥΜΕΡΑ",
    "stats.title": "Η ακαδημία σε αριθμούς",
    "stats.certs": "Πιστοποιητικά",
    "stats.students": "Εκπαιδευόμενοι",
    "testi.eyebrow": "ΚΡΙΤΙΚΕΣ",
    "testi.title": "Τι λένε",
    "testi.title2": "οι μαθητές μας.",
    "testi1.text": "Είχα διαβάσει δεκάδες άρθρα για φυσιολογία, αλλά εδώ πρώτη φορά κατάλαβα πώς συνδέονται τα ενεργειακά συστήματα με την προπόνηση που γράφω.",
    "testi1.name": "Γιώργος Π.",
    "testi1.role": "Προπονητής Ποδοσφαίρου",
    "testi2.text": "Τα quiz μετά από κάθε ενότητα με ανάγκασαν να μάθω σωστά την ύλη. Η ανάλυση των λαθών είναι το καλύτερο κομμάτι.",
    "testi2.name": "Μαρία Κ.",
    "testi2.role": "Φοιτήτρια ΣΕΦΑΑ",
    "testi3.text": "Το κάνω από το κινητό στα διαλείμματα της δουλειάς. Οι σημειώσεις ανά ενότητα με κρατούν οργανωμένη.",
    "testi3.name": "Ελένη Δ.",
    "testi3.role": "Personal Trainer",
    "faq.eyebrow": "ΑΠΟΡΙΕΣ",
    "faq.title": "Συχνές ερωτήσεις",
    "faq1.q": "Χρειάζομαι προηγούμενες γνώσεις;",
    "faq1.a": "Όχι. Κάθε μάθημα έχει επίπεδο (Αρχάριο, Μεσαίο, Προχωρημένο) και ξεκινά από τα θεμέλια. Διάλεξε το επίπεδο που σου ταιριάζει και προχώρα με τον ρυθμό σου.",
    "faq2.q": "Πόσος χρόνος χρειάζεται για ένα μάθημα;",
    "faq2.a": "Κάθε ενότητα διαρκεί περίπου 15-25 λεπτά μαζί με το quiz. Μπορείς να σταματήσεις και να συνεχίσεις όποτε θέλεις — η πρόοδός σου αποθηκεύεται αυτόματα.",
    "faq3.q": "Τι γίνεται αν αποτύχω σε ένα quiz;",
    "faq3.a": "Δεν χάνεται τίποτα. Βλέπεις αναλυτικά ποιες απαντήσεις ήταν λάθος και ποια ήταν η σωστή, και μπορείς να επαναλάβεις το quiz όσες φορές θέλεις. Χρειάζεσαι 60% για να ολοκληρωθεί η ενότητα.",
    "faq4.q": "Μπορώ να το κάνω από κινητό;",
    "faq4.a": "Ναι. Η πλατφόρμα είναι 100% online και λειτουργεί σε κινητό, tablet και υπολογιστή, χωρίς εγκατάσταση εφαρμογής.",
    "faq5.q": "Πώς παρακολουθώ την πρόοδό μου;",
    "faq5.a": "Στη σελίδα «Η Πρόοδός μου» βλέπεις ποσοστά ολοκλήρωσης ανά μάθημα, μέσο όρο στα quiz, τις αγαπημένες σου ενότητες και όλο το ιστορικό προσπαθειών.",
    "footer.rights": "Όλα τα δικαιώματα διατηρούνται",
    "nav.leaderboard": "Κατάταξη",
    "nav.mentorship": "Mentorship",
    "b2b.eyebrow": "ΓΙΑ ΟΜΑΔΕΣ & ΟΡΓΑΝΙΣΜΟΥΣ",
    "b2b.title": "Για Ακαδημίες, Συλλόγους & Γυμναστήρια",
    "b2b.subtitle": "Εκπαίδευσε όλο το προπονητικό σου επιτελείο με την ίδια, επιστημονικά ελεγμένη ύλη. Από 5 θέσεις και πάνω, με κλιμακωτή έκπτωση, κοινό dashboard προόδου και τιμολόγιο.",
    "b2b.ben1": "Κοινό dashboard προόδου για όλη την ομάδα — ποιος ολοκλήρωσε, ποιος πιστοποιήθηκε",
    "b2b.ben2": "Μηνιαίες αναφορές απόδοσης & ολοκλήρωσης για τη διοίκηση",
    "b2b.ben3": "Τιμολόγιο στον οργανισμό και δυνατότητα πληρωμής σε δόσεις",
    "b2b.ben4": "Προσαρμοσμένο onboarding & προαιρετικό ομαδικό mentorship",
    "b2b.calcTitle": "Υπολόγισε την ομαδική τιμή",
    "b2b.seats": "θέσεις",
    "b2b.seatsLabel": "Αριθμός θέσεων",
    "b2b.course": "Μάθημα ή πακέτο",
    "b2b.perSeat": "Ανά θέση",
    "b2b.total": "Σύνολο",
    "b2b.formTitle": "Ζήτησε προσφορά",
    "b2b.formSubtitle": "Συμπλήρωσε τη φόρμα και θα λάβεις εξατομικευμένη προσφορά και τιμολόγιο εντός 1 εργάσιμης ημέρας.",
    "b2b.step1": "Σου στέλνουμε προσφορά και σύμβαση",
    "b2b.step2": "Ενεργοποιούμε τις θέσεις για τους συνεργάτες σου",
    "b2b.step3": "Παρακολουθείς την πρόοδο από το dashboard της ομάδας",
    "b2b.organization": "Οργανισμός / Σύλλογος",
    "b2b.messagePh": "Πες μας λίγα λόγια: ποιες ειδικότητες, πόσα άτομα, πότε θέλετε να ξεκινήσετε…",
    "b2b.quote": "Ενδεικτική προσφορά",
    "b2b.submit": "Στείλε αίτημα προσφοράς",
    "b2b.sent": "Το αίτημα στάλθηκε!",
    "b2b.sentBody": "Θα επικοινωνήσουμε μαζί σου εντός 1 εργάσιμης ημέρας.",
    "nav.b2b": "Για Ομάδες",
    "certs.diploma": "Δίπλωμα Learning Path",
    "nav.team": "Ομάδα",
    "team.eyebrow": "TEAM DASHBOARD",
    "team.subtitle": "Πρόοδος, ολοκληρώσεις και πιστοποιήσεις όλων των θέσεων του οργανισμού σου.",
    "team.seats": "Θέσεις",
    "team.registered": "Εγγεγραμμένοι",
    "team.avgProgress": "Μέση πρόοδος",
    "team.certificates": "Πιστοποιήσεις",
    "team.member": "Μέλος",
    "team.certs": "Πιστ.",
    "team.pending": "Δεν έχει εγγραφεί ακόμα",
    "team.certified": "Πιστοποιήθηκε",
    "team.noMembers": "Δεν έχουν προστεθεί μέλη ακόμα.",
    "team.noTeam": "Δεν είσαι υπεύθυνος κάποιας ομάδας",
    "team.noTeamBody": "Αν ο οργανισμός σου έχει ομαδική συνδρομή, ζήτησε από την Ακαδημία να σε ορίσει υπεύθυνο.",
    "orgs.new": "Νέος οργανισμός",
    "orgs.edit": "Επεξεργασία οργανισμού",
    "orgs.name": "Όνομα οργανισμού / συλλόγου",
    "orgs.manager": "Email υπευθύνου",
    "orgs.seats": "Αριθμός θέσεων",
    "orgs.members": "Emails μελών (ένα ανά γραμμή)",
    "orgs.courses": "Μαθήματα που περιλαμβάνονται",
    "orgs.save": "Αποθήκευση",
    "orgs.cancel": "Άκυρο",
    "orgs.editBtn": "Επεξεργασία",
    "orgs.saved": "Ο οργανισμός αποθηκεύτηκε και οι θέσεις ενεργοποιήθηκαν",
    "orgs.empty": "Δεν υπάρχουν οργανισμοί ακόμα.",
    "path.included": "Τι περιλαμβάνει το μονοπάτι",
    "path.includedSub": "Μία αγορά, πρόσβαση σε όλα τα μαθήματα και 1 πιστοποίηση για το καθένα.",
    "path.badge": "Πακέτο μαθημάτων",
    "science.eyebrow": "Η ΕΠΙΣΤΗΜΟΝΙΚΗ ΟΜΑΔΑ",
    "science.title": "Πίσω από κάθε ενότητα, μια ολόκληρη επιστημονική ομάδα",
    "science.body": "Η ύλη της ακαδημίας αναπτύσσεται και ελέγχεται από επιστημονική επιτροπή αποφοίτων ΤΕΦΑΑ, κατόχων MSc/PhD στην Αθλητική Επιστήμη, S&C coaches επαγγελματικών ομάδων, φυσιοθεραπευτών και αναλυτών δεδομένων. Κάθε ενότητα περνά από peer-review πριν δημοσιευτεί και ανανεώνεται κάθε χρόνο με βάση τη νέα έρευνα — ώστε αυτό που μαθαίνεις να είναι αυτό που εφαρμόζεται σήμερα στα γήπεδα και τα γυμναστήρια.",
    "science.r1": "Αθλητική Φυσιολογία",
    "science.r1b": "Ενεργειακά συστήματα, φορτίο, προσαρμογές — με πηγές από τη σύγχρονη βιβλιογραφία.",
    "science.r2": "Strength & Conditioning",
    "science.r2b": "Coaches με εμπειρία σε επαγγελματικές ομάδες ποδοσφαίρου και μπάσκετ.",
    "science.r3": "Αποκατάσταση & Υγεία",
    "science.r3b": "Φυσιοθεραπευτές και ιατροί αθλητισμού για ασφαλή πρωτόκολλα επιστροφής.",
    "science.r4": "Data & AI",
    "science.r4b": "Αναλυτές απόδοσης που μετατρέπουν GPS, HRV και βίντεο σε αποφάσεις.",
    "science.s1": "επιστήμονες & coaches",
    "science.s2": "επιστημονικές μελέτες στη βιβλιογραφία",
    "science.s3": "της ύλης με peer-review",
    "science.s4": "ανανέωση ύλης",
    "mentorship.badge": "Career Mentorship",
    "mentorship.title": "Mentorship για την καριέρα σου",
    "mentorship.subtitle": "Διάλεξε 1-1 συνάντηση ή ομάδα 4-5 ατόμων για επίλυση επαγγελματικών προβλημάτων, συζήτηση και κατεύθυνση καριέρας με τους εισηγητές της Academy.",
    "mentorship.one_on_one.title": "1-1 Mentoring",
    "mentorship.one_on_one.desc": "Ιδιωτική συνάντηση 60' αποκλειστικά για τη δική σου περίπτωση.",
    "mentorship.one_on_one.p1": "Ανάλυση της τρέχουσας επαγγελματικής σου κατάστασης",
    "mentorship.one_on_one.p2": "Συγκεκριμένο πλάνο ενεργειών 90 ημερών",
    "mentorship.one_on_one.p3": "Follow-up email με σημειώσεις",
    "mentorship.group.title": "Group Mentoring (4-5 άτομα)",
    "mentorship.group.desc": "Ομαδική συνάντηση 90' με συναδέλφους που αντιμετωπίζουν παρόμοια θέματα.",
    "mentorship.group.p1": "Career problem-solving πάνω σε πραγματικές περιπτώσεις",
    "mentorship.group.p2": "Ανταλλαγή εμπειριών & networking",
    "mentorship.group.p3": "Κοινά εργαλεία και checklists",
    "mentorship.formTitle": "Αίτηση",
    "mentorship.topic": "Θέμα",
    "mentorship.topicPh": "π.χ. Πώς να ξεκινήσω online coaching",
    "mentorship.availability": "Διαθεσιμότητα",
    "mentorship.availabilityPh": "π.χ. Απογεύματα Τρ/Πε μετά τις 18:00",
    "mentorship.goal": "Στόχος καριέρας",
    "mentorship.goalPh": "Τι θέλεις να έχεις πετύχει σε 6 μήνες;",
    "mentorship.message": "Μήνυμα / περιγραφή της κατάστασης",
    "mentorship.send": "Αποστολή αίτησης",
    "mentorship.sent": "Η αίτησή σου στάλθηκε! Θα επικοινωνήσουμε σύντομα.",
    "mentorship.loginFirst": "Σύνδεση για αίτηση",
    "mentorship.paid": "Η πληρωμή ολοκληρώθηκε! Θα επικοινωνήσουμε για την ημερομηνία.",
    "mentorship.cancelled": "Η πληρωμή ακυρώθηκε.",
    "mentorship.mine": "Οι αιτήσεις μου",
    "mentorship.join": "Σύνδεση",
    "mentorship.status.pending_payment": "Εκκρεμεί πληρωμή",
    "mentorship.status.new": "Νέα",
    "mentorship.status.scheduled": "Προγραμματισμένη",
    "mentorship.status.completed": "Ολοκληρωμένη",
    "program.price": "Δίδακτρα",
    "program.duration": "Διάρκεια",
    "program.months": "μήνες",
    "program.start": "Έναρξη",
    "program.schedule": "Πρόγραμμα",
    "program.accessTitle": "Έχεις κωδικό πρόσβασης;",
    "program.accessPlaceholder": "Κωδικός τμήματος",
    "program.accessCta": "Απόκτησε πρόσβαση",
    "program.accessHint": "Ο κωδικός δίνεται από την ακαδημία μετά την εγγραφή σου στο πρόγραμμα.",
    "program.locked": "Κλειδωμένη",
    "program.unlocksOn": "Ξεκλειδώνει",
    "program.noLessons": "Η ύλη του προγράμματος ανακοινώνεται σύντομα.",
    "program.week": "Εβδομάδα",
    "sessions.title": "Live Συναντήσεις",
    "sessions.next": "Επόμενη live συνάντηση",
    "sessions.join": "Είσοδος",
    "sessions.recording": "Επανάληψη",
    "sessions.empty": "Δεν έχουν προγραμματιστεί συναντήσεις ακόμα.",
    "sessions.min": "λεπτά",
    "gam.xp": "Πόντοι XP",
    "gam.level": "Επίπεδο",
    "gam.next": "μέχρι το επόμενο επίπεδο",
    "gam.badges": "Διακρίσεις",
    "gam.noBadges": "Ολοκλήρωσε ενότητες για να ξεκλειδώσεις διακρίσεις.",
    "gam.leaderboardCta": "Δες την κατάταξη",
    "badge.first_step": "Πρώτο Βήμα",
    "badge.perfect": "Τελειομανής",
    "badge.consistent": "Συνεπής",
    "badge.graduate": "Απόφοιτος",
    "badge.elite": "Elite",
    "lb.title": "Πίνακας Κατάταξης",
    "lb.subtitle": "ΦΙΛΙΚΟΣ ΑΝΤΑΓΩΝΙΣΜΟΣ",
    "lb.rank": "#",
    "lb.student": "Μαθητής",
    "lb.xp": "XP",
    "lb.lessons": "Ενότητες",
    "lb.you": "Εσύ",
    "lb.empty": "Δεν υπάρχουν ακόμα μαθητές στην κατάταξη.",
    "cert.title": "Πιστοποιητικά",
    "cert.view": "Πιστοποιητικό",
    "cert.print": "Εκτύπωση / PDF",
    "cert.empty": "Ολοκλήρωσε ένα πρόγραμμα για να λάβεις το πιστοποιητικό σου.",
    "cert.heading": "ΠΙΣΤΟΠΟΙΗΤΙΚΟ ΟΛΟΚΛΗΡΩΣΗΣ",
    "cert.awarded": "Απονέμεται στον/στην",
    "cert.for": "για την επιτυχή ολοκλήρωση του προγράμματος",
    "cert.code": "Κωδικός",
    "cert.date": "Ημερομηνία",
    "cert.avg": "Μέσος όρος quiz",
    "cert.months": "Διάρκεια",
    "cert.signature": "SportScience Academy — Founder",
    "cert.back": "Πίσω στην πρόοδό μου",
    "admin.tab.programs": "Προγράμματα",
    "admin.tab.sessions": "Live Συναντήσεις",
    "admin.tab.students": "Μαθητές",
    "admin.field.price": "Δίδακτρα (€)",
    "admin.field.start": "Ημερομηνία έναρξης",
    "admin.field.code": "Κωδικός πρόσβασης τμήματος",
    "admin.field.months": "Διάρκεια (μήνες)",
    "admin.field.schedule": "Πρόγραμμα συναντήσεων",
    "admin.field.week": "Εβδομάδα ξεκλειδώματος",
    "admin.newSession": "Νέα συνάντηση",
    "admin.editSession": "Επεξεργασία συνάντησης",
    "admin.field.when": "Ημερομηνία & ώρα",
    "admin.field.duration": "Διάρκεια (λεπτά)",
    "admin.field.meetingUrl": "Link συνάντησης (Zoom/Meet)",
    "admin.field.recordingUrl": "Link επανάληψης",
    "admin.exportCsv": "Εξαγωγή CSV",
    "admin.noStudents": "Δεν υπάρχουν μαθητές ακόμα.",
    "admin.progress": "Πρόοδος",
    "admin.lastActivity": "Τελευταία δραστηριότητα",
    "admin.selectProgram": "Διάλεξε πρόγραμμα από τη λίστα.",
    "admin.students.programs": "Προγράμματα",
    "admin.students.avg": "Μ.Ο. quiz",
    "admin.students.name": "Όνομα",
    "lead.eyebrow": "ΑΙΤΗΣΗ ΕΝΔΙΑΦΕΡΟΝΤΟΣ",
    "lead.title": "Θέλεις να μπεις",
    "lead.title2": "στο επόμενο τμήμα;",
    "lead.subtitle": "Άφησε τα στοιχεία σου και θα σου στείλουμε το πρόγραμμα, τις ημερομηνίες και τον κωδικό πρόσβασης του τμήματος.",
    "lead.name": "Ονοματεπώνυμο",
    "lead.email": "Email",
    "lead.phone": "Τηλέφωνο",
    "lead.program": "Πρόγραμμα που σε ενδιαφέρει",
    "lead.programAny": "Δεν έχω αποφασίσει ακόμα",
    "lead.message": "Μήνυμα (προαιρετικό)",
    "lead.submit": "Στείλε την αίτηση",
    "lead.success": "Λάβαμε την αίτησή σου! Θα επικοινωνήσουμε σύντομα.",
    "lead.successTitle": "Ευχαριστούμε!",
    "lead.successText": "Η αίτησή σου καταχωρήθηκε και σου στείλαμε email επιβεβαίωσης.",
    "admin.tab.leads": "Αιτήσεις",
    "admin.leads.empty": "Δεν υπάρχουν αιτήσεις ακόμα.",
    "admin.leads.new": "Νέα",
    "admin.leads.contacted": "Επικοινωνήσαμε",
    "admin.leads.markToggle": "Αλλαγή κατάστασης",
    "sales.cohort": "Εγγραφή οποτεδήποτε",
    "sales.selfPaced": "Εξ αποστάσεως · με τον ρυθμό σου",
    "sales.mentorIncluded": "1-1 Mentorship κάθε 2 ενότητες",
    "sales.buyNow": "Απόκτησε πρόσβαση",
    "sales.viewSyllabus": "Δες την ύλη",
    "sales.mentorRow": "1-1 Mentorship: λύσε απορίες & συζήτησε τις 2 προηγούμενες ενότητες με mentor",
    "sales.bookMentor": "Κλείσε συνεδρία",
    "sales.caseStudy": "Real Case Study",
    "sales.caseVideo": "Βαθμολογούμενη εργασία",
    "sales.caseDataset": "Κατέβασε το dataset (CSV)",
    "sales.sp1t": "Αγορά & άμεση πρόσβαση",
    "sales.sp1d": "Πληρώνεις μία φορά με Stripe και οι 28 ενότητες ανοίγουν αμέσως. Μελετάς με τον δικό σου ρυθμό.",
    "sales.sp2t": "Ύλη, case studies & quizzes",
    "sales.sp2d": "Κάθε module έχει real case study με δεδομένα και βαθμολογούμενη εργασία, διαδραστικές διαφάνειες και quiz αυτοαξιολόγησης.",
    "sales.apply": "Κάνε αίτηση συμμετοχής",
    "sales.haveCode": "Έχω κωδικό πρόσβασης",
    "sales.h1": "Ρυθμός μάθησης",
    "sales.h2": "Ενότητες ύλης",
    "sales.h3": "Μάθηση",
    "sales.h3v": "Case studies & διαδραστικά quiz",
    "sales.h4": "Πιστοποιητικό",
    "sales.h4v": "Ολοκλήρωσης",
    "sales.benefitsEyebrow": "ΓΙΑΤΙ ΑΥΤΟ ΤΟ ΠΡΟΓΡΑΜΜΑ",
    "sales.benefitsTitle": "Τι κερδίζεις με αυτό το μάθημα",
    "sales.b1": "Δομημένη ύλη βασισμένη στην αθλητική επιστήμη, με εφαρμογή στην πράξη.",
    "sales.b2": "Πραγματικά case studies με δεδομένα και βαθμολογούμενες εργασίες που διορθώνει mentor.",
    "sales.b3": "Quiz μετά από κάθε ενότητα με αναλυτική επεξήγηση των λαθών.",
    "sales.b4": "Πρόσβαση στην πλατφόρμα από κινητό, tablet και υπολογιστή.",
    "sales.b5": "Παρακολούθηση προόδου, σημειώσεις και αγαπημένες ενότητες.",
    "sales.b6": "Πιστοποιητικό ολοκλήρωσης με τον κωδικό επαλήθευσής σου.",
    "sales.syllabusEyebrow": "ΠΡΟΓΡΑΜΜΑ ΣΠΟΥΔΩΝ",
    "sales.syllabusTitle": "Η ύλη μήνα-μήνα",
    "sales.syllabusSubtitle": "Όλη η ύλη είναι ανοιχτή από την πρώτη μέρα — προχωράς με τον δικό σου ρυθμό, με διαδραστικές ενότητες, quiz και case studies.",
    "sales.month": "Μήνας",
    "sales.s1t": "1. Κάνεις αίτηση",
    "sales.s1d": "Αγοράζεις το πρόγραμμα online και η πρόσβαση ενεργοποιείται αμέσως.",
    "sales.s2t": "2. Παίρνεις κωδικό",
    "sales.s2d": "Μόλις ολοκληρωθεί η πληρωμή, όλα τα modules ξεκλειδώνουν στον λογαριασμό σου.",
    "sales.s3t": "3. Ξεκινάς",
    "sales.s3d": "Μελετάς την ύλη, συμμετέχεις στις live συναντήσεις και ολοκληρώνεις τα quiz.",
    "nav.apply": "Κάνε αίτηση",
    "inst.eyebrow": "ΟΙ ΕΙΣΗΓΗΤΕΣ",
    "inst.title": "Ποιοι θα σε εκπαιδεύσουν",
    "pay.eyebrow": "ΤΡΟΠΟΙ ΠΛΗΡΩΜΗΣ",
    "pay.title": "Δίδακτρα & δόσεις",
    "pay.full": "Εφάπαξ",
    "pay.fullDesc": "Μία πληρωμή για όλο το πρόγραμμα.",
    "pay.plan": "Με δόσεις",
    "pay.deposit": "Προκαταβολή",
    "pay.monthly": "/μήνα",
    "pay.installments": "μηνιαίες δόσεις",
    "pay.from": "Από",
    "nav.diplomas": "Διπλώματα",
    "diplomas.title": "LIVE Διπλώματα 6 μηνών",
    "diplomas.subtitle": "Τρία live διπλώματα με έναρξη 12 Ιανουαρίου 2027: συναντήσεις κάθε Τρίτη και Σάββατο, ατομικό career mentorship κάθε μήνα και έως 20 θέσεις το καθένα.",
    "diplomas.cta": "Δες το δίπλωμα",
    "live.calEyebrow": "ΗΜΕΡΟΛΟΓΙΟ LIVE",
    "live.calTitle": "Οι live συναντήσεις, μήνα-μήνα",
    "live.calSubtitle": "Κάθε Τρίτη 19:30–21:00 και κάθε Σάββατο 17:00–18:30, από τις 12 Ιανουαρίου 2027 για έξι μήνες.",
    "live.calNote": "Όλες οι συναντήσεις γίνονται live και μαγνητοσκοπούνται, ώστε να τις ξαναδείς όποτε θέλεις.",
    "live.ebBadge": "Early bird −20%",
    "live.ebTitle": "Early bird: −20% για εγγραφές έως 12/12/2026",
    "live.ebText": "Αν κλείσεις τη θέση σου μέχρι τις 12 Δεκεμβρίου 2026, η έκπτωση 20% ισχύει τόσο στην εγγραφή όσο και σε όλες τις δόσεις.",
    "live.calDays": "Τρίτη & Σάββατο",
    "landing.diplomas.title": "LIVE Διπλώματα με έναρξη Ιανουάριο 2027",
    "landing.diplomas.all": "Όλα τα διπλώματα",
    "live.async": "Ασύγχρονη παρακολούθηση",
    "live.asyncBadge": "Και μαγνητοσκοπημένα",
    "live.asyncTitle": "Δεν προλαβαίνεις live; Κανένα πρόβλημα",
    "live.asyncText": "Κάθε συνάντηση μαγνητοσκοπείται και ανεβαίνει στην πλατφόρμα, ώστε να την παρακολουθήσεις ασύγχρονα όποτε σε βολεύει και να τη δεις ξανά όσες φορές θέλεις — χωρίς να χάνεις τίποτα από την ύλη.",
    "live.asyncShort": "Όλες οι συναντήσεις μαγνητοσκοπούνται για ασύγχρονη παρακολούθηση.",
    "live.ebWas": "Κανονική τιμή",
    "live.ebDaysLeft": "ημέρες για early bird",
    "live.ebOneDayLeft": "Τελευταία ημέρα για early bird",
    "admin.field.instDiplomas": "Σε ποια διπλώματα διδάσκει",
    "pay.note": "Η πληρωμή γίνεται online με κάρτα και η πρόσβαση ενεργοποιείται αμέσως.",
    "live.badge": "LIVE Δίπλωμα",
    "live.start": "Επίσημη έναρξη",
    "live.duration": "Διάρκεια",
    "live.durationV": "6 μήνες",
    "live.seats": "Θέσεις",
    "live.seatsV": "Μέγιστες 20",
    "live.format": "Μορφή",
    "live.formatV": "Live συναντήσεις",
    "live.mentorship": "Career mentorship",
    "live.mentorshipV": "6 × 45' ατομικά",
    "live.mentorshipTitle": "Προσωπικό career mentorship κάθε μήνα",
    "live.mentorshipText": "Μία ατομική συνεδρία 45' τον μήνα — 6 συνολικά μέσα στο εξάμηνο — με καταξιωμένους επαγγελματίες του χώρου, προσαρμοσμένη στους δικούς σου στόχους και επιθυμίες.",
    "live.instructorsTitle": "Οι εισηγητές",
    "live.instructorsTba": "Οι εισηγητές του προγράμματος θα ανακοινωθούν προσεχώς.",
    "live.outlineEyebrow": "ΥΛΗ ΜΕ ΜΙΑ ΜΑΤΙΑ",
    "live.outlineTitle": "Η ύλη επιγραμματικά, μήνα-μήνα",
    "live.outlineSubtitle": "Έξι μήνες δομημένης ύλης με live συναντήσεις κάθε Τρίτη και Σάββατο.",
    "live.assignment": "Εργασία ενότητας",
    "live.detailedTitle": "Αναλυτική ύλη",
    "live.detailedSubtitle": "Η πλήρης λίστα ενοτήτων που καλύπτεται μέσα στο εξάμηνο.",
    "live.payTitle": "Δίδακτρα",
    "live.payRegistration": "Εγγραφή",
    "live.payInstallments": "δόσεις των",
    "live.payTotal": "Σύνολο διδάκτρων",
    "live.payNote": "Η εγγραφή κατοχυρώνει τη θέση σου και οι υπόλοιπες δόσεις καταβάλλονται μηνιαίως κατά τη διάρκεια του προγράμματος.",
    "live.interestTitle": "Εκδήλωσε ενδιαφέρον",
    "live.interestText": "Συμπλήρωσε τα στοιχεία σου και θα επικοινωνήσουμε μαζί σου για τη διαδικασία εγγραφής και τις διαθέσιμες θέσεις.",
    "live.interestName": "Ονοματεπώνυμο",
    "live.interestEmail": "Email",
    "live.interestPhone": "Τηλέφωνο",
    "live.interestMessage": "Πες μας λίγα λόγια για τους στόχους σου (προαιρετικό)",
    "live.interestSend": "Στείλε εκδήλωση ενδιαφέροντος",
    "live.interestOk": "Ευχαριστούμε! Λάβαμε την εκδήλωση ενδιαφέροντός σου και θα επικοινωνήσουμε σύντομα.",
    "live.interestErr": "Κάτι πήγε στραβά. Δοκίμασε ξανά σε λίγο.",
    "live.b1": "Live συναντήσεις με εισηγητές και ομάδα συμφοιτητών, όχι απλώς βιντεομαθήματα.",
    "live.b2": "Κάθε συνάντηση μαγνητοσκοπείται, ώστε να την παρακολουθήσεις ασύγχρονα αν δεν προλαβαίνεις live.",
    "live.b3": "Ατομικό career mentorship 45' κάθε μήνα, με βάση τους δικούς σου στόχους.",
    "live.b4": "Μικρό τμήμα έως 20 ατόμων, ώστε να υπάρχει χώρος για ερωτήσεις και συζήτηση.",
    "live.b5": "Ύλη εφαρμοσμένη σε πραγματικές ομάδες και επιχειρήσεις του χώρου.",
    "live.b6": "Δίπλωμα ολοκλήρωσης με κωδικό επαλήθευσης στο τέλος του εξαμήνου.",
    "admin.tab.instructors": "Εισηγητές",
    "admin.newInstructor": "Νέος εισηγητής",
    "admin.field.instName": "Ονοματεπώνυμο",
    "admin.field.instTitle": "Τίτλος / ιδιότητα",
    "admin.field.instBio": "Βιογραφικό",
    "admin.field.instPhoto": "Φωτογραφία (link)",
    "admin.field.instOrder": "Σειρά εμφάνισης",
    "admin.field.deposit": "Προκαταβολή (€)",
    "admin.field.installments": "Μηνιαίες δόσεις",
    "admin.instructors.empty": "Δεν έχεις προσθέσει εισηγητές.",
    "common.loading": "Φόρτωση...",
    "common.error": "Κάτι πήγε στραβά",
  },
  en: {
    "nav.courses": "Courses",
    "nav.games": "Games",
    "nav.certificates": "Certificates",
    "certs.badge": "My credentials",
    "certs.title": "My Certificates",
    "certs.subtitle": "Every certificate you have earned, one click away from your LinkedIn profile.",
    "certs.empty": "No certificates yet. Finish a course and pass the final quiz with 90%.",
    "certs.browse": "Browse courses",
    "certs.verified": "Verifiable certificate",
    "certs.internal": "SportScience certificate",
    "certs.holder": "Issued to",
    "certs.downloadPdf": "Download PDF",
    "live.interactive": "Interactive lesson",
    "live.slidesDone": "You completed the interactive slides!",
    "live.slidesScore": "Correct",
    "live.restart": "Restart",
    "live.fullText": "Full lesson text (from basics to advanced)",
    "badges.title": "My badges",
    "badges.subtitle": "A unique badge for every course you complete — plus Bronze, Silver and Gold tiers as you progress.",
    "badges.courses": "courses",
    "badges.next": "Next tier",
    "badges.moreCourses": "more course(s)",
    "badges.empty": "Complete your first course to earn your first badge!",
    "badges.share": "LinkedIn",
    "badges.youEarn": "What you earn",
    "badges.courseBadge": "Completion badge + certificate",
    "badges.courseBadgeDesc": "Pass the final quiz to earn this course's unique badge (PNG for LinkedIn) and a certificate with ID, barcode and QR.",
    "verify.badge": "Verification",
    "verify.title": "Certificate Verification",
    "verify.valid": "Valid certificate",
    "verify.invalid": "Certificate not found",
    "verify.invalidHint": "Check the ID or rescan the barcode/QR on the certificate.",
    "verify.issued": "Issued on",
    "certs.score": "Score",
    "certs.addLinkedin": "Add to LinkedIn",
    "certs.verify": "Verify",
    "certs.openCourse": "Open course",
    "certs.instagram": "Instagram card",
    "certs.cardBadge": "Certification complete",
    "certs.cardReady": "Card downloaded! Share it on Instagram.",
    "certs.cardError": "Could not generate the card.",
    "admin.tab.sales": "Sales",
    "admin.sales.empty": "No sales yet.",
    "admin.sales.total": "Sales",
    "admin.sales.revenue": "Revenue",
    "admin.sales.pending": "Pending",
    "admin.sales.enrollments": "Enrollments",
    "admin.sales.certificates": "Certificates",
    "admin.sales.byCourse": "By course",
    "admin.sales.byCoupon": "By discount code",
    "nav.learn": "Interactive",
    "nav.academy": "Online Courses",
    "academy.badge": "Self-paced courses",
    "academy.title": "Online Courses for Coaches",
    "academy.subtitle": "Short, interactive courses built on slides, checkpoints and role-playing scenarios. Ready-made content, certificate of completion and lifetime access after purchase.",
    "academy.filters": "Filters",
    "academy.allCategories": "All categories",
    "academy.allPrices": "All prices",
    "academy.freeOnly": "Free",
    "academy.empty": "No courses match these filters.",
    "academy.free": "Free",
    "academy.owned": "Owned",
    "academy.details": "Course guide",
    "academy.continue": "Continue",
    "academy.backToCatalog": "Back to courses",
    "academy.whatYouLearn": "What you will learn",
    "academy.syllabus": "Syllabus",
    "academy.faq": "Frequently asked questions",
    "cfaq1.q": "When do I start and how long is access?",
    "cfaq1.a": "Right after purchase. Access is lifetime — study at your own pace from desktop or mobile.",
    "cfaq2.q": "How do the interactive lessons work?",
    "cfaq2.a": "Each lesson combines theory slides, checkpoints, matching exercises and role-playing scenarios. You earn XP and badges as you progress.",
    "cfaq3.q": "How do I get the certificate?",
    "cfaq3.a": "Complete all lessons and pass the final quiz (90%). Your certificate with a unique ID, barcode and QR verification is emailed automatically and can be shared on LinkedIn.",
    "cfaq4.q": "Is the material available in English?",
    "cfaq4.a": "Yes, all online courses are bilingual. Switch language any time from the menu.",
    "cfaq5.q": "Can I try before I buy?",
    "cfaq5.a": "Yes — the first lesson of every course is a free preview. Hit “Try for free” to see it.",
    "academy.slides": "slides",
    "academy.slide": "Slide",
    "academy.previewFree": "free preview",
    "academy.locked": "Locked",
    "academy.oneTime": "One payment, lifetime access",
    "academy.selfPaced": "self-paced",
    "academy.certificateAt": "Certificate at 90% on the final quiz",
    "academy.youHaveAccess": "You have access to this course",
    "academy.buyNow": "Get access",
    "academy.paymentNote": "Secure payment by card, Google Pay, Apple Pay or Klarna.",
    "academy.tryPreview": "Try the free preview",
    "academy.finalQuiz": "Final quiz & certificate",
    "academy.ownCert": "Verifiable SportScience Academy certificate with QR & unique ID",
    "cert.previewEyebrow": "What you earn",
    "cert.previewTitle": "Sample certificate",
    "cert.certifies": "This certifies that",
    "cert.holderPlaceholder": "Your Name",
    "cert.completed": "has successfully completed",
    "cert.hours": "hours of training",
    "cert.idLine": "Credential ID · verification QR",
    "cert.verified": "Verified by SportScience Academy",
    "cert.previewNote": "The certificate is issued digitally by SportScience Academy with a unique ID, barcode and verification QR, and can be shared on LinkedIn.",
    "courses.tabLive": "7-month Diplomas (self-paced)",
    "courses.tabOnline": "Online courses",
    "academy.bilingual": "Available in Greek & English — switch language inside the course",
    "academy.manualIncluded": "Includes the full manual (PDF)",
    "academy.downloadManual": "Download the manual (PDF)",
    "academy.quizIntro": "You need 90% to earn the certificate. You can retake it as many times as you like.",
    "academy.attempts": "Attempts",
    "academy.submitQuiz": "Submit",
    "academy.passed": "Passed! Your certificate has been issued.",
    "academy.failed": "You did not reach 90% — try again.",
    "academy.retry": "Try again",
    "academy.certificateIssued": "Certificate",
    "academy.coachNote": "Coach note",
    "academy.couponPlaceholder": "Discount code",
    "academy.couponApply": "Apply",
    "academy.couponApplied": "Code applied!",
    "admin.tab.coupons": "Coupons",
    "admin.newCoupon": "New coupon",
    "admin.coupons.empty": "No coupons yet.",
    "admin.coupons.saved": "Coupon saved",
    "academy.verifyCertificate": "Open verifiable certificate",
    "admin.coupons.used": "Uses",
    "admin.coupons.expires": "Expires",
    "admin.coupons.active": "Active",
    "admin.coupons.inactive": "Inactive",
    "admin.field.couponCode": "Code",
    "admin.field.couponType": "Type",
    "admin.field.couponPercent": "Percentage (%)",
    "admin.field.couponAmount": "Fixed amount (€)",
    "admin.field.couponValue": "Discount value",
    "admin.field.couponMaxUses": "Max uses (0 = unlimited)",
    "admin.field.couponExpires": "Expiry date",
    "academy.nextSlide": "Next slide",
    "payment.checking": "Confirming your payment...",
    "payment.success": "Payment complete!",
    "payment.accessGranted": "The course has been unlocked in your account.",
    "payment.startNow": "Start now",
    "payment.pending": "Payment is pending. Access unlocks automatically once confirmed.",
    "payment.failed": "The payment did not go through.",
    "payment.cancelled": "Payment cancelled",
    "payment.cancelledNote": "Nothing was charged. You can try again anytime.",
    "admin.tab.academy": "Online Courses",
    "admin.newAcademyCourse": "New online course",
    "admin.newAcademyLesson": "New lesson",
    "admin.academy.empty": "No online courses yet.",
    "admin.academy.slidesHelp": "Slides as JSON: slide, checkpoint, match, order, scenario.",
    "admin.field.academySlug": "Slug (URL)",
    "admin.field.academyCategory": "Category",
    "admin.field.academyLevel": "Level",
    "admin.field.academyHours": "Hours",
    "admin.field.academyPrice": "Price (€)",
    "admin.field.academyOriginal": "Original price (€)",
    "admin.field.academyLookup": "Stripe lookup key",
    "admin.field.academyPreview": "Free preview",
    "admin.field.academySlides": "Slides (JSON)",
    "admin.field.academyQuiz": "Final quiz (JSON)",
    "learn.badge": "Interactive learning",
    "learn.title": "Interactive Courses",
    "learn.subtitle": "Learn step by step: bite-sized theory, checkpoints with instant feedback, exercises and role-playing scenarios where you make the coach's calls.",
    "learn.empty": "No interactive courses yet.",
    "learn.lessons": "lessons",
    "learn.steps": "steps",
    "learn.start": "Start",
    "learn.continueCourse": "Continue",
    "learn.review": "Review",
    "learn.back": "Back",
    "learn.step": "Step",
    "learn.lessonNo": "Lesson",
    "learn.theory": "Theory",
    "learn.checkpoint": "Checkpoint",
    "learn.exercise": "Exercise",
    "learn.roleplay": "Role-playing",
    "learn.gotIt": "Got it",
    "learn.continue": "Continue",
    "learn.correct": "Correct!",
    "learn.notQuite": "Not quite.",
    "learn.matchHint": "Pick an item on the left, then its match on the right.",
    "learn.reset": "Reset",
    "learn.decision": "Decision",
    "learn.consequence": "Consequence",
    "learn.nextDecision": "Next decision",
    "learn.debrief": "Debrief",
    "learn.completed": "Completed",
    "learn.alreadyDone": "You had already completed this — no XP this time.",
    "learn.nextLesson": "Next lesson",
    "learn.again": "Again",
    "admin.tab.learn": "Interactive",
    "admin.newLearnCourse": "New interactive course",
    "admin.newLearnLesson": "New lesson",
    "admin.learn.empty": "No interactive courses yet.",
    "admin.learn.lessonsFor": "Lessons",
    "admin.learn.blocksHelp": "Blocks as JSON: theory, checkpoint, match, order, scenario.",
    "admin.field.learnSubtitle": "Subtitle",
    "admin.field.learnBlocks": "Blocks (JSON)",
    "admin.field.learnXp": "XP",
    "games.badge": "Learn by playing",
    "games.title": "Games",
    "games.subtitle": "Seven quick games that lock in the material: timed questions, a true/false sprint, flashcards, memory pairs, guess-the-term, training scenarios and the Weekly Challenge. Earn XP, collect points and compete on the leaderboard.",
    "games.cta": "Play & learn",
    "games.play": "Play",
    "games.playAgain": "Play again",
    "games.back": "Back to games",
    "games.best": "Best",
    "games.plays": "plays",
    "games.noContent": "No content yet.",
    "games.leaderboard": "Games leaderboard",
    "games.leaderboardEmpty": "Nobody has played yet. Be the first!",
    "games.xpToday": "XP from games today",
    "games.capReached": "You hit today's XP cap from games. Keep playing for fun!",
    "games.result": "Result",
    "games.correct": "Correct",
    "games.accuracy": "Accuracy",
    "games.xpEarned": "XP earned",
    "games.question": "Question",
    "games.scenario": "Scenario",
    "games.true": "True",
    "games.false": "False",
    "games.term": "Term",
    "games.answer": "Answer",
    "games.reveal": "Reveal answer",
    "games.knew": "I knew it",
    "games.didntKnow": "I didn't know",
    "games.yourOrder": "Your order",
    "games.availableSteps": "Available steps",
    "games.pickSteps": "Pick the steps in the right order.",
    "games.undo": "Undo",
    "games.finish": "Finish",
    "games.nextScenario": "Next scenario",
    "games.hint": "Answers are graded on the server — good luck!",
    "games.quiz-rush.title": "Quiz Rush",
    "games.quiz-rush.desc": "10 questions, 15 seconds each. Keep the streak alive.",
    "games.tf-sprint.title": "True / False Sprint",
    "games.tf-sprint.desc": "60 seconds. Get as many right as you can.",
    "games.flashcards.title": "Flashcards",
    "games.flashcards.desc": "Term cards that repeat whatever you missed.",
    "games.build-session.title": "Build the Session",
    "games.build-session.desc": "Put the steps of a training session in the right order.",
    "games.memory-match.title": "Memory Match",
    "games.memory-match.desc": "Match 6 terms with their definitions in 90 seconds. Fewer moves, sharper memory.",
    "games.word-guess.title": "Guess the Term",
    "games.word-guess.desc": "Read the description and type the sports-science term. The first letter is given.",
    "games.weekly-challenge.title": "Weekly Challenge",
    "games.weekly-challenge.desc": "15 questions, the same for everyone this week. The board resets every Monday — take the top spot!",
    "games.moves": "Moves",
    "games.typeWord": "Type the term…",
    "games.guess": "Answer",
    "games.skip": "Skip",
    "games.week": "Week",
    "games.weeklyBoard": "This Week's Board",
    "games.weeklyBoardHint": "Only the Weekly Challenge counts here. Resets every Monday.",
    "coach.badge": "Coach",
    "coach.title": "Well done, you did it!",
    "coach.lessonDone": "Well done, you did it!",
    "coach.courseDone": "Congratulations, you passed!",
    "coach.newBadge": "New badge",
    "coach.noBadges": "Keep going — your first badges are coming soon!",
    "coach.continue": "Continue",
    "learn.video": "Video",
    "badge.game_master": "Game Master",
    "admin.tab.games": "Games",
    "admin.newGameItem": "New item",
    "admin.games.empty": "No game items yet.",
    "admin.field.gameType": "Type",
    "admin.field.gamePrompt": "Question / Term / Scenario",
    "admin.field.gameOptions": "Options (one per line)",
    "admin.field.gameCorrect": "Correct option (0-3)",
    "admin.field.gameAnswer": "The statement is true",
    "admin.field.gameBack": "Card back",
    "admin.field.gameSteps": "Steps in correct order (one per line)",
    "admin.field.gameExplanation": "Explanation",
    "admin.field.gameCategory": "Category",
    "nav.articles": "Articles",
    "articles.badge": "Blog & Knowledge",
    "articles.title": "Articles",
    "articles.subtitle": "Practical knowledge for coaches and athletes: strength & conditioning, testing, injury prevention and periodisation.",
    "articles.empty": "No articles yet.",
    "articles.read": "Read",
    "articles.back": "Back to articles",
    "newsletter.badge": "Newsletter",
    "newsletter.title": "Get every new article in your inbox",
    "newsletter.subtitle": "Subscribe and we will email you every time a new SportScience Academy article goes live. No spam, unsubscribe anytime.",
    "newsletter.placeholder": "Your email",
    "newsletter.cta": "Subscribe",
    "newsletter.success": "You are subscribed!",
    "admin.tab.articles": "Articles",
    "admin.tab.subscribers": "Newsletter",
    "admin.newArticle": "New article",
    "admin.articles.empty": "No articles yet.",
    "admin.subscribers.empty": "No subscribers yet.",
    "admin.articles.published": "Published",
    "admin.articles.draft": "Draft",
    "admin.articles.sendNewsletter": "Send newsletter",
    "admin.articles.sent": "Newsletter sent",
    "admin.field.artTitle": "Title",
    "admin.field.artExcerpt": "Excerpt",
    "admin.field.artContent": "Body",
    "admin.field.artCover": "Cover image (URL)",
    "admin.field.artAuthor": "Author",
    "admin.field.artPublished": "Publish (sends newsletter)",
    "nav.dashboard": "My Progress",
    "nav.admin": "Admin",
    "nav.login": "Log in",
    "nav.register": "Sign up",
    "nav.logout": "Log out",
    "hero.badge": "Online Sports Education",
    "hero.title1": "Build Skills.",
    "hero.title2": "Become an Expert.",
    "hero.subtitle": "SportScience Academy gives you access to sport science courses with structured material, a quiz after every lesson and full progress tracking — wherever you are.",
    "hero.cta": "Start Now",
    "hero.cta2": "Browse Courses",
    "stats.courses": "Courses",
    "stats.lessons": "Lessons",
    "stats.quiz": "Quizzes",
    "features.title": "Why SportScience Academy",
    "features.subtitle": "A platform built for results, not just attendance.",
    "feature1.title": "Structured Material",
    "feature1.desc": "Every course is organised into clear lessons with solid theory and applied sport science practice.",
    "feature2.title": "Quiz after every lesson",
    "feature2.desc": "Instant scoring after each quiz. You always know where you stand and what to revise.",
    "feature3.title": "Progress Tracking",
    "feature3.desc": "A personal dashboard with completion rates and average quiz performance per course.",
    "feature4.title": "Learn Anywhere",
    "feature4.desc": "100% online, from any device, at your own pace and on your own schedule.",
    "landing.popular.title": "Popular Courses",
    "landing.popular.subtitle": "The courses our students pick most",
    "landing.courses.title": "Popular Programs",
    "landing.online.title": "Online Academy Courses",
    "landing.online.subtitle": "Learn at your own pace",
    "landing.online.desc": "Interactive courses with slides, checkpoints and certification. Sign in, get access and start right away.",
    "landing.courses.subtitle": "Start from the foundations of sport science",
    "landing.cta.title": "Ready to level up?",
    "landing.cta.subtitle": "Create an account and start your first course today.",
    "courses.title": "Course Catalog",
    "courses.subtitle": "Pick the next step in your development",
    "courses.lessons": "lessons",
    "courses.view": "View Course",
    "level.Beginner": "Beginner",
    "level.Intermediate": "Intermediate",
    "level.Advanced": "Advanced",
    "auth.login.title": "Welcome back",
    "auth.login.subtitle": "Log in to pick up where you left off.",
    "auth.register.title": "Create your account",
    "auth.register.subtitle": "Start your sport science journey today.",
    "auth.name": "Full name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.login.submit": "Log in",
    "auth.register.submit": "Create Account",
    "auth.noAccount": "Don't have an account?",
    "auth.hasAccount": "Already have an account?",
    "auth.forgot.link": "Forgot your password?",
    "auth.forgot.title": "Reset your password",
    "auth.forgot.subtitle": "Enter your email and we'll send you a secure link to set a new password.",
    "auth.forgot.submit": "Send me a link",
    "auth.forgot.sentTitle": "Check your email",
    "auth.forgot.sentBody": "If an account exists for that email, we just sent a reset link. It expires in 1 hour.",
    "auth.reset.title": "Set a new password",
    "auth.reset.subtitle": "Choose a new password with at least 6 characters.",
    "auth.reset.newPassword": "New password",
    "auth.reset.confirm": "Confirm password",
    "auth.reset.submit": "Save password",
    "auth.reset.mismatch": "Passwords do not match.",
    "auth.reset.invalidTitle": "Invalid link",
    "auth.reset.invalidBody": "This reset link is not valid. Request a new one to continue.",
    "auth.reset.done": "Password updated. Log in with your new password.",
    "course.enroll": "Enroll in Course",
    "course.enrolled": "You are enrolled",
    "course.curriculum": "Course Curriculum",
    "course.progress": "Progress",
    "course.back": "Back to courses",
    "course.start": "Start",
    "course.quizCount": "questions",
    "lesson.content": "Lesson Material",
    "lesson.completed": "Completed",
    "lesson.next": "Next Lesson",
    "lesson.backToCourse": "Back to Course",
    "quiz.title": "Assessment Quiz",
    "quiz.subtitle": "Answer the questions to complete this lesson. You need at least 60%.",
    "quiz.submit": "Submit Answers",
    "quiz.score": "Your Score",
    "quiz.passed": "Passed! Lesson completed.",
    "quiz.failed": "Not this time. Try again!",
    "quiz.retake": "Retake Quiz",
    "quiz.selectAll": "Answer all questions before submitting.",
    "dash.title": "My Progress",
    "dash.subtitle": "Your stats and enrolled courses",
    "dash.enrolled": "Enrolled Courses",
    "dash.completed": "Completed Lessons",
    "dash.attempts": "Quiz Attempts",
    "dash.avg": "Average Quiz Score",
    "dash.myCourses": "My Courses",
    "dash.continue": "Continue",
    "dash.empty": "You haven't enrolled in any course yet.",
    "dash.browse": "Browse Courses",
    "admin.title": "Platform Administration",
    "admin.subtitle": "Create and edit courses, lessons and quizzes",
    "admin.courses": "Courses",
    "admin.newCourse": "New Course",
    "admin.editCourse": "Edit Course",
    "admin.lessons": "Lessons",
    "admin.newLesson": "New Lesson",
    "admin.editLesson": "Edit Lesson",
    "admin.field.title": "Title",
    "admin.field.description": "Description",
    "admin.field.category": "Category",
    "admin.field.level": "Level",
    "admin.field.thumbnail": "Image URL",
    "admin.field.content": "Lesson Content",
    "admin.field.video": "Video URL (YouTube/mp4, optional)",
    "admin.save": "Save",
    "admin.cancel": "Cancel",
    "admin.delete": "Delete",
    "admin.edit": "Edit",
    "admin.quiz": "Quiz Questions",
    "admin.addQuestion": "Add Question",
    "admin.question": "Question",
    "admin.options": "Options",
    "admin.correct": "Correct Answer",
    "admin.removeQuestion": "Remove",
    "admin.selectCourse": "Select a course to edit or create a new one.",
    "admin.saved.course": "Course saved",
    "admin.saved.lesson": "Lesson saved",
    "admin.deleted.course": "Course deleted",
    "admin.deleted.lesson": "Lesson deleted",
    "courses.search": "Search courses...",
    "courses.allCategories": "All categories",
    "courses.allLevels": "All levels",
    "courses.noResults": "No courses match these filters.",
    "courses.results": "results",
    "lesson.notes": "My Notes",
    "lesson.notesPlaceholder": "Take notes for this lesson...",
    "lesson.notesSave": "Save Notes",
    "lesson.notesSaved": "Notes saved",
    "lesson.bookmark": "Save to Bookmarks",
    "lesson.bookmarked": "Bookmarked",
    "quiz.review": "Answer Review",
    "quiz.yourAnswer": "Your answer",
    "quiz.correctAnswer": "Correct answer",
    "quiz.history": "Attempt History",
    "quiz.historyEmpty": "You haven't attempted this quiz yet.",
    "quiz.showReview": "Show review",
    "quiz.hideReview": "Hide review",
    "dash.bookmarks": "Bookmarked Lessons",
    "dash.bookmarksEmpty": "You haven't bookmarked any lesson yet.",
    "dash.history": "Quiz History",
    "dash.historyEmpty": "No quiz attempts yet.",
    "dash.open": "Open",
    "brand.tagline": "LEARN THE SCIENCE. CHANGE THE GAME.",
    "hero.eyebrow": "LEARN. APPLY. STAND OUT.",
    "hero.block1": "Your skills.",
    "hero.block2": "Your knowledge.",
    "hero.block3": "Your game.",
    "hero.tag": "Learn online. Apply on the field. Stand out anywhere.",
    "cats.eyebrow": "PICK A CATEGORY",
    "cats.title": "Popular course",
    "cats.title2": "categories.",
    "cat.physiology": "Physiology & Training",
    "cat.business": "Business in Fitness",
    "cat.populations": "Special Populations",
    "cat.wellbeing": "Wellbeing Coaching",
    "cat.sports": "Football & Basketball",
    "why.eyebrow": "WHY SPORTSCIENCE ACADEMY",
    "why.title": "One platform. Countless opportunities.",
    "why1.title": "Gamified Learning",
    "why1.desc": "Interactive slides, checkpoints, games and XP. Learn by playing, compete on the weekly board and get cheered on by the Coach after every win.",
    "why2.title": "Role-Playing Scenarios",
    "why2.desc": "Step into the coach's or trainer's shoes, make decisions in realistic scenarios and see the consequences — just like on the pitch or the gym floor.",
    "why3.title": "Verifiable Certifications",
    "why3.desc": "Every certificate carries a unique ID, barcode and QR verification. Share it on LinkedIn and show employers what you know.",
    "why4.title": "Career Mentorship",
    "why4.desc": "1-1 or in groups of 4-5, solve real career problems with experienced professionals in the field.",
    "why5.title": "Greek & English",
    "why5.desc": "All material is bilingual: study in Greek, master the terminology in English and get ready for an international career.",
    "cat.nutrition": "Nutrition",
    "cat.strength": "Training",
    "cat.biomechanics": "Biomechanics",
    "cat.psychology": "Psychology",
    "steps.eyebrow": "HOW IT WORKS",
    "steps.title": "Four steps.",
    "steps.title2": "One path.",
    "steps.subtitle": "From your first lesson to your first certified skill.",
    "step1.title": "Start with your goal",
    "step1.desc": "Picture the career you want in fitness and sport science. We show you the path.",
    "step2.title": "Learn through Role-Playing",
    "step2.desc": "Interactive slides, decision scenarios and games that put you in the professional's shoes.",
    "step3.title": "Earn your certification",
    "step3.desc": "Pass the final assessment and receive a certificate with a unique ID, barcode and QR verification.",
    "step4.title": "Land the job you want",
    "step4.desc": "Share certificates on LinkedIn, use mentorship and accelerate your career.",
    "stats.eyebrow": "THE NUMBERS",
    "stats.title": "The academy in numbers",
    "stats.certs": "Certificates",
    "stats.students": "Learners",
    "testi.eyebrow": "REVIEWS",
    "testi.title": "What our",
    "testi.title2": "students say.",
    "testi1.text": "I had read dozens of articles on physiology, but this is the first time I understood how energy systems connect to the sessions I write.",
    "testi1.name": "George P.",
    "testi1.role": "Football Coach",
    "testi2.text": "The quiz after every lesson forced me to actually learn the material. The answer review is the best part.",
    "testi2.name": "Maria K.",
    "testi2.role": "Sport Science Student",
    "testi3.text": "I study from my phone during work breaks. The per-lesson notes keep me organised.",
    "testi3.name": "Eleni D.",
    "testi3.role": "Personal Trainer",
    "faq.eyebrow": "QUESTIONS",
    "faq.title": "Frequently asked",
    "faq1.q": "Do I need prior knowledge?",
    "faq1.a": "No. Every course has a level (Beginner, Intermediate, Advanced) and starts from the foundations. Pick the level that fits you and move at your own pace.",
    "faq2.q": "How long does a lesson take?",
    "faq2.a": "Each lesson takes about 15-25 minutes including the quiz. You can stop and continue whenever you want — your progress is saved automatically.",
    "faq3.q": "What if I fail a quiz?",
    "faq3.a": "Nothing is lost. You see exactly which answers were wrong and what the correct one was, and you can retake the quiz as many times as you like. You need 60% to complete the lesson.",
    "faq4.q": "Can I use it on mobile?",
    "faq4.a": "Yes. The platform is 100% online and works on phone, tablet and desktop with no app install.",
    "faq5.q": "How do I track my progress?",
    "faq5.a": "On the My Progress page you see completion rates per course, your average quiz score, your bookmarked lessons and your full attempt history.",
    "footer.rights": "All rights reserved",
    "nav.leaderboard": "Leaderboard",
    "nav.mentorship": "Mentorship",
    "b2b.eyebrow": "FOR TEAMS & ORGANISATIONS",
    "b2b.title": "For Academies, Clubs & Gyms",
    "b2b.subtitle": "Train your whole coaching staff on the same scientifically reviewed material. From 5 seats, with tiered discounts, a shared progress dashboard and invoicing.",
    "b2b.ben1": "Shared progress dashboard for the whole team — who finished, who got certified",
    "b2b.ben2": "Monthly performance & completion reports for management",
    "b2b.ben3": "Invoice to the organisation and instalment options",
    "b2b.ben4": "Custom onboarding & optional group mentorship",
    "b2b.calcTitle": "Calculate your team price",
    "b2b.seats": "seats",
    "b2b.seatsLabel": "Number of seats",
    "b2b.course": "Course or bundle",
    "b2b.perSeat": "Per seat",
    "b2b.total": "Total",
    "b2b.formTitle": "Request a quote",
    "b2b.formSubtitle": "Fill in the form and receive a tailored quote and invoice within 1 business day.",
    "b2b.step1": "We send you a quote and agreement",
    "b2b.step2": "We activate the seats for your staff",
    "b2b.step3": "You track progress from the team dashboard",
    "b2b.organization": "Organisation / Club",
    "b2b.messagePh": "Tell us a bit: which roles, how many people, when you want to start…",
    "b2b.quote": "Indicative quote",
    "b2b.submit": "Send quote request",
    "b2b.sent": "Request sent!",
    "b2b.sentBody": "We will get back to you within 1 business day.",
    "nav.b2b": "For Teams",
    "certs.diploma": "Learning Path Diploma",
    "nav.team": "Team",
    "team.eyebrow": "TEAM DASHBOARD",
    "team.subtitle": "Progress, completions and certifications across all seats of your organisation.",
    "team.seats": "Seats",
    "team.registered": "Registered",
    "team.avgProgress": "Avg. progress",
    "team.certificates": "Certificates",
    "team.member": "Member",
    "team.certs": "Certs",
    "team.pending": "Not registered yet",
    "team.certified": "Certified",
    "team.noMembers": "No members added yet.",
    "team.noTeam": "You are not managing a team",
    "team.noTeamBody": "If your organisation has a team subscription, ask the Academy to set you as manager.",
    "orgs.new": "New organisation",
    "orgs.edit": "Edit organisation",
    "orgs.name": "Organisation / club name",
    "orgs.manager": "Manager email",
    "orgs.seats": "Number of seats",
    "orgs.members": "Member emails (one per line)",
    "orgs.courses": "Included courses",
    "orgs.save": "Save",
    "orgs.cancel": "Cancel",
    "orgs.editBtn": "Edit",
    "orgs.saved": "Organisation saved and seats activated",
    "orgs.empty": "No organisations yet.",
    "path.included": "What the path includes",
    "path.includedSub": "One purchase, access to every course and a certificate for each.",
    "path.badge": "Course bundle",
    "science.eyebrow": "THE SCIENTIFIC TEAM",
    "science.title": "Behind every lesson, a whole scientific team",
    "science.body": "The academy's material is developed and reviewed by a scientific committee of Sport Science graduates, MSc/PhD holders in Sport Science, S&C coaches of professional teams, physiotherapists and data analysts. Every lesson is peer-reviewed before release and refreshed every year based on new research — so what you learn is what is applied today on pitches and in gyms.",
    "science.r1": "Exercise Physiology",
    "science.r1b": "Energy systems, load, adaptations — sourced from current literature.",
    "science.r2": "Strength & Conditioning",
    "science.r2b": "Coaches with professional football and basketball experience.",
    "science.r3": "Rehab & Health",
    "science.r3b": "Physiotherapists and sports physicians for safe return protocols.",
    "science.r4": "Data & AI",
    "science.r4b": "Performance analysts turning GPS, HRV and video into decisions.",
    "science.s1": "scientists & coaches",
    "science.s2": "studies in the literature",
    "science.s3": "of material peer-reviewed",
    "science.s4": "content refresh",
    "mentorship.badge": "Career Mentorship",
    "mentorship.title": "Mentorship for your career",
    "mentorship.subtitle": "Pick a 1-1 session or a group of 4-5 for career problem-solving, discussion and direction with Academy instructors.",
    "mentorship.one_on_one.title": "1-1 Mentoring",
    "mentorship.one_on_one.desc": "A private 60' session focused entirely on your case.",
    "mentorship.one_on_one.p1": "Analysis of your current professional situation",
    "mentorship.one_on_one.p2": "A concrete 90-day action plan",
    "mentorship.one_on_one.p3": "Follow-up email with notes",
    "mentorship.group.title": "Group Mentoring (4-5 people)",
    "mentorship.group.desc": "A 90' group session with peers facing similar challenges.",
    "mentorship.group.p1": "Career problem-solving on real cases",
    "mentorship.group.p2": "Experience sharing & networking",
    "mentorship.group.p3": "Shared tools and checklists",
    "mentorship.formTitle": "Request",
    "mentorship.topic": "Topic",
    "mentorship.topicPh": "e.g. How to start online coaching",
    "mentorship.availability": "Availability",
    "mentorship.availabilityPh": "e.g. Tue/Thu evenings after 18:00",
    "mentorship.goal": "Career goal",
    "mentorship.goalPh": "What do you want to achieve in 6 months?",
    "mentorship.message": "Message / describe your situation",
    "mentorship.send": "Send request",
    "mentorship.sent": "Your request was sent! We will contact you soon.",
    "mentorship.loginFirst": "Log in to request",
    "mentorship.paid": "Payment complete! We'll contact you to schedule.",
    "mentorship.cancelled": "Payment cancelled.",
    "mentorship.mine": "My requests",
    "mentorship.join": "Join",
    "mentorship.status.pending_payment": "Pending payment",
    "mentorship.status.new": "New",
    "mentorship.status.scheduled": "Scheduled",
    "mentorship.status.completed": "Completed",
    "program.price": "Tuition",
    "program.duration": "Duration",
    "program.months": "months",
    "program.start": "Starts",
    "program.schedule": "Schedule",
    "program.accessTitle": "Got an access code?",
    "program.accessPlaceholder": "Cohort code",
    "program.accessCta": "Get access",
    "program.accessHint": "The code is provided by the academy once you join the program.",
    "program.locked": "Locked",
    "program.unlocksOn": "Unlocks",
    "program.noLessons": "The program material will be announced soon.",
    "program.week": "Week",
    "sessions.title": "Live Sessions",
    "sessions.next": "Next live session",
    "sessions.join": "Join",
    "sessions.recording": "Recording",
    "sessions.empty": "No sessions scheduled yet.",
    "sessions.min": "min",
    "gam.xp": "XP Points",
    "gam.level": "Level",
    "gam.next": "to the next level",
    "gam.badges": "Badges",
    "gam.noBadges": "Complete lessons to unlock badges.",
    "gam.leaderboardCta": "See the leaderboard",
    "badge.first_step": "First Step",
    "badge.perfect": "Perfectionist",
    "badge.consistent": "Consistent",
    "badge.graduate": "Graduate",
    "badge.elite": "Elite",
    "lb.title": "Leaderboard",
    "lb.subtitle": "FRIENDLY COMPETITION",
    "lb.rank": "#",
    "lb.student": "Student",
    "lb.xp": "XP",
    "lb.lessons": "Lessons",
    "lb.you": "You",
    "lb.empty": "No students on the leaderboard yet.",
    "cert.title": "Certificates",
    "cert.view": "Certificate",
    "cert.print": "Print / PDF",
    "cert.empty": "Complete a program to earn your certificate.",
    "cert.heading": "CERTIFICATE OF COMPLETION",
    "cert.awarded": "Awarded to",
    "cert.for": "for successfully completing the program",
    "cert.code": "Code",
    "cert.date": "Date",
    "cert.avg": "Quiz average",
    "cert.months": "Duration",
    "cert.signature": "SportScience Academy — Founder",
    "cert.back": "Back to my progress",
    "admin.tab.programs": "Programs",
    "admin.tab.sessions": "Live Sessions",
    "admin.tab.students": "Students",
    "admin.field.price": "Tuition (€)",
    "admin.field.start": "Start date",
    "admin.field.code": "Cohort access code",
    "admin.field.months": "Duration (months)",
    "admin.field.schedule": "Session schedule",
    "admin.field.week": "Unlock week",
    "admin.newSession": "New session",
    "admin.editSession": "Edit session",
    "admin.field.when": "Date & time",
    "admin.field.duration": "Duration (minutes)",
    "admin.field.meetingUrl": "Meeting link (Zoom/Meet)",
    "admin.field.recordingUrl": "Recording link",
    "admin.exportCsv": "Export CSV",
    "admin.noStudents": "No students yet.",
    "admin.progress": "Progress",
    "admin.lastActivity": "Last activity",
    "admin.selectProgram": "Pick a program from the list.",
    "admin.students.programs": "Programs",
    "admin.students.avg": "Quiz avg",
    "admin.students.name": "Name",
    "lead.eyebrow": "APPLY FOR A SPOT",
    "lead.title": "Want to join",
    "lead.title2": "the next cohort?",
    "lead.subtitle": "Leave your details and we will send you the curriculum, the dates and the cohort access code.",
    "lead.name": "Full name",
    "lead.email": "Email",
    "lead.phone": "Phone",
    "lead.program": "Program you are interested in",
    "lead.programAny": "Not decided yet",
    "lead.message": "Message (optional)",
    "lead.submit": "Send application",
    "lead.success": "We received your application! We will be in touch soon.",
    "lead.successTitle": "Thank you!",
    "lead.successText": "Your application was received and a confirmation email is on its way.",
    "admin.tab.leads": "Applications",
    "admin.leads.empty": "No applications yet.",
    "admin.leads.new": "New",
    "admin.leads.contacted": "Contacted",
    "admin.leads.markToggle": "Toggle status",
    "sales.cohort": "Enrol any time",
    "sales.selfPaced": "Self-paced · online",
    "sales.mentorIncluded": "1-1 Mentorship every 2 lessons",
    "sales.buyNow": "Get access",
    "sales.viewSyllabus": "View syllabus",
    "sales.mentorRow": "1-1 Mentorship: clear doubts & discuss the previous 2 lessons with a mentor",
    "sales.bookMentor": "Book session",
    "sales.caseStudy": "Real Case Study",
    "sales.caseVideo": "Graded assignment",
    "sales.caseDataset": "Download dataset (CSV)",
    "sales.sp1t": "Buy & instant access",
    "sales.sp1d": "Pay once via Stripe and all 28 lessons unlock immediately. Study at your own pace.",
    "sales.sp2t": "Content, case studies & quizzes",
    "sales.sp2d": "Every module has a real case study with data and a graded assignment, interactive slides and self-assessment quizzes.",
    "sales.apply": "Apply for a spot",
    "sales.haveCode": "I have an access code",
    "sales.h1": "Learning pace",
    "sales.h2": "Lessons",
    "sales.h3": "Learning",
    "sales.h3v": "Case studies & interactive quizzes",
    "sales.h4": "Certificate",
    "sales.h4v": "Of completion",
    "sales.benefitsEyebrow": "WHY THIS PROGRAM",
    "sales.benefitsTitle": "What you get with this course",
    "sales.b1": "Structured, sport-science based curriculum with hands-on application.",
    "sales.b2": "Real case studies with data and graded assignments reviewed by a mentor.",
    "sales.b3": "A quiz after every lesson with a full review of your mistakes.",
    "sales.b4": "Platform access from phone, tablet and desktop.",
    "sales.b5": "Progress tracking, personal notes and bookmarked lessons.",
    "sales.b6": "Certificate of completion with your own verification code.",
    "sales.syllabusEyebrow": "CURRICULUM",
    "sales.syllabusTitle": "The curriculum month by month",
    "sales.syllabusSubtitle": "All material is open from day one — learn at your own pace with interactive lessons, quizzes and case studies.",
    "sales.month": "Month",
    "sales.s1t": "1. You apply",
    "sales.s1d": "You buy the programme online and access is activated instantly.",
    "sales.s2t": "2. You get a code",
    "sales.s2d": "As soon as payment is complete, every module unlocks in your account.",
    "sales.s3t": "3. You start",
    "sales.s3d": "Study the material, join the live sessions and complete the quizzes.",
    "nav.apply": "Apply now",
    "inst.eyebrow": "THE INSTRUCTORS",
    "inst.title": "Who will train you",
    "pay.eyebrow": "PAYMENT OPTIONS",
    "pay.title": "Tuition & instalments",
    "pay.full": "One payment",
    "pay.fullDesc": "A single payment for the whole program.",
    "pay.plan": "Instalment plan",
    "pay.deposit": "Deposit",
    "pay.monthly": "/month",
    "pay.installments": "monthly instalments",
    "pay.from": "From",
    "nav.diplomas": "Diplomas",
    "diplomas.title": "6-month LIVE Diplomas",
    "diplomas.subtitle": "Three live diplomas starting 12 January 2027: sessions every Tuesday and Saturday, one-to-one career mentorship every month and up to 20 seats each.",
    "diplomas.cta": "View the diploma",
    "live.calEyebrow": "LIVE CALENDAR",
    "live.calTitle": "The live sessions, month by month",
    "live.calSubtitle": "Every Tuesday 19:30–21:00 and every Saturday 17:00–18:30, from 12 January 2027 for six months.",
    "live.calNote": "All sessions are held live and recorded, so you can watch them again whenever you want.",
    "live.ebBadge": "Early bird −20%",
    "live.ebTitle": "Early bird: −20% for registrations until 12/12/2026",
    "live.ebText": "Secure your seat by 12 December 2026 and the 20% discount applies both to the registration and to every installment.",
    "live.calDays": "Tuesday & Saturday",
    "landing.diplomas.title": "LIVE Diplomas starting January 2027",
    "landing.diplomas.all": "All diplomas",
    "live.async": "Asynchronous access",
    "live.asyncBadge": "Recorded too",
    "live.asyncTitle": "Can't make it live? No problem",
    "live.asyncText": "Every session is recorded and uploaded to the platform, so you can watch it asynchronously whenever it suits you and replay it as many times as you like — without missing any of the content.",
    "live.asyncShort": "All sessions are recorded for asynchronous viewing.",
    "live.ebWas": "Regular price",
    "live.ebDaysLeft": "days left for early bird",
    "live.ebOneDayLeft": "Last day for early bird",
    "admin.field.instDiplomas": "Teaches in which diplomas",
    "pay.note": "Payment is made online by card and access is activated instantly.",
    "live.badge": "LIVE Diploma",
    "live.start": "Official start",
    "live.duration": "Duration",
    "live.durationV": "6 months",
    "live.seats": "Seats",
    "live.seatsV": "Max 20",
    "live.format": "Format",
    "live.formatV": "Live sessions",
    "live.mentorship": "Career mentorship",
    "live.mentorshipV": "6 × 45' one-to-one",
    "live.mentorshipTitle": "Personal career mentorship every month",
    "live.mentorshipText": "One 45-minute one-to-one session per month — 6 in total across the six months — with established professionals in the field, tailored to your own goals and ambitions.",
    "live.instructorsTitle": "The instructors",
    "live.instructorsTba": "The instructors of this programme will be announced soon.",
    "live.outlineEyebrow": "SYLLABUS AT A GLANCE",
    "live.outlineTitle": "The syllabus, month by month",
    "live.outlineSubtitle": "Six months of structured content with live sessions every Tuesday and Saturday.",
    "live.assignment": "Module assignment",
    "live.detailedTitle": "Detailed syllabus",
    "live.detailedSubtitle": "The full list of units covered during the six months.",
    "live.payTitle": "Tuition",
    "live.payRegistration": "Registration",
    "live.payInstallments": "installments of",
    "live.payTotal": "Total tuition",
    "live.payNote": "The registration secures your seat and the remaining installments are paid monthly during the programme.",
    "live.interestTitle": "Register your interest",
    "live.interestText": "Leave your details and we will contact you about the enrolment process and seat availability.",
    "live.interestName": "Full name",
    "live.interestEmail": "Email",
    "live.interestPhone": "Phone",
    "live.interestMessage": "Tell us about your goals (optional)",
    "live.interestSend": "Send my interest",
    "live.interestOk": "Thank you! We received your request and will be in touch shortly.",
    "live.interestErr": "Something went wrong. Please try again shortly.",
    "live.b1": "Live sessions with instructors and a cohort of peers, not just recorded videos.",
    "live.b2": "Every session is recorded, so you can watch it asynchronously if you cannot attend live.",
    "live.b3": "A 45-minute one-to-one career mentorship session every month, built around your goals.",
    "live.b4": "A small cohort of up to 20 people, so there is room for questions and discussion.",
    "live.b5": "Content applied to real teams and real businesses in the field.",
    "live.b6": "A diploma of completion with a verification code at the end of the six months.",
    "admin.tab.instructors": "Instructors",
    "admin.newInstructor": "New instructor",
    "admin.field.instName": "Full name",
    "admin.field.instTitle": "Title / role",
    "admin.field.instBio": "Bio",
    "admin.field.instPhoto": "Photo (link)",
    "admin.field.instOrder": "Display order",
    "admin.field.deposit": "Deposit (€)",
    "admin.field.installments": "Monthly instalments",
    "admin.instructors.empty": "No instructors added yet.",
    "common.loading": "Loading...",
    "common.error": "Something went wrong",
  },
};
